(() => {
// packages/alpinejs/src/scheduler.js
var $5599ea74f46bbff6$var$flushPending = false;
var $5599ea74f46bbff6$var$flushing = false;
var $5599ea74f46bbff6$var$queue = [];
var $5599ea74f46bbff6$var$lastFlushedIndex = -1;
var $5599ea74f46bbff6$var$transactionActive = false;
function $5599ea74f46bbff6$var$scheduler(callback) {
    $5599ea74f46bbff6$var$queueJob(callback);
}
function $5599ea74f46bbff6$var$startTransaction() {
    $5599ea74f46bbff6$var$transactionActive = true;
}
function $5599ea74f46bbff6$var$commitTransaction() {
    $5599ea74f46bbff6$var$transactionActive = false;
    $5599ea74f46bbff6$var$queueFlush();
}
function $5599ea74f46bbff6$var$queueJob(job) {
    if (!$5599ea74f46bbff6$var$queue.includes(job)) $5599ea74f46bbff6$var$queue.push(job);
    $5599ea74f46bbff6$var$queueFlush();
}
function $5599ea74f46bbff6$var$dequeueJob(job) {
    let index = $5599ea74f46bbff6$var$queue.indexOf(job);
    if (index !== -1 && index > $5599ea74f46bbff6$var$lastFlushedIndex) $5599ea74f46bbff6$var$queue.splice(index, 1);
}
function $5599ea74f46bbff6$var$queueFlush() {
    if (!$5599ea74f46bbff6$var$flushing && !$5599ea74f46bbff6$var$flushPending) {
        if ($5599ea74f46bbff6$var$transactionActive) return;
        $5599ea74f46bbff6$var$flushPending = true;
        queueMicrotask($5599ea74f46bbff6$var$flushJobs);
    }
}
function $5599ea74f46bbff6$var$flushJobs() {
    $5599ea74f46bbff6$var$flushPending = false;
    $5599ea74f46bbff6$var$flushing = true;
    for(let i = 0; i < $5599ea74f46bbff6$var$queue.length; i++){
        $5599ea74f46bbff6$var$queue[i]();
        $5599ea74f46bbff6$var$lastFlushedIndex = i;
    }
    $5599ea74f46bbff6$var$queue.length = 0;
    $5599ea74f46bbff6$var$lastFlushedIndex = -1;
    $5599ea74f46bbff6$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $5599ea74f46bbff6$var$reactive;
var $5599ea74f46bbff6$var$effect;
var $5599ea74f46bbff6$var$release;
var $5599ea74f46bbff6$var$raw;
var $5599ea74f46bbff6$var$shouldSchedule = true;
function $5599ea74f46bbff6$var$disableEffectScheduling(callback) {
    $5599ea74f46bbff6$var$shouldSchedule = false;
    callback();
    $5599ea74f46bbff6$var$shouldSchedule = true;
}
function $5599ea74f46bbff6$var$setReactivityEngine(engine) {
    $5599ea74f46bbff6$var$reactive = engine.reactive;
    $5599ea74f46bbff6$var$release = engine.release;
    $5599ea74f46bbff6$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($5599ea74f46bbff6$var$shouldSchedule) $5599ea74f46bbff6$var$scheduler(task);
                else task();
            }
        });
    $5599ea74f46bbff6$var$raw = engine.raw;
}
function $5599ea74f46bbff6$var$overrideEffect(override) {
    $5599ea74f46bbff6$var$effect = override;
}
function $5599ea74f46bbff6$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $5599ea74f46bbff6$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $5599ea74f46bbff6$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $5599ea74f46bbff6$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let oldValueJSON;
    let effectReference = $5599ea74f46bbff6$var$effect(()=>{
        let value = getter();
        let newJSON = JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = typeof oldValue === "object" ? JSON.parse(oldValueJSON) : oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        oldValueJSON = newJSON;
        firstTime = false;
    });
    return ()=>$5599ea74f46bbff6$var$release(effectReference);
}
async function $5599ea74f46bbff6$var$transaction(callback) {
    $5599ea74f46bbff6$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $5599ea74f46bbff6$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $5599ea74f46bbff6$var$onAttributeAddeds = [];
var $5599ea74f46bbff6$var$onElRemoveds = [];
var $5599ea74f46bbff6$var$onElAddeds = [];
function $5599ea74f46bbff6$var$onElAdded(callback) {
    $5599ea74f46bbff6$var$onElAddeds.push(callback);
}
function $5599ea74f46bbff6$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $5599ea74f46bbff6$var$onElRemoveds.push(callback);
    }
}
function $5599ea74f46bbff6$var$onAttributesAdded(callback) {
    $5599ea74f46bbff6$var$onAttributeAddeds.push(callback);
}
function $5599ea74f46bbff6$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $5599ea74f46bbff6$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $5599ea74f46bbff6$var$cleanupElement(el) {
    el._x_effects?.forEach($5599ea74f46bbff6$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $5599ea74f46bbff6$var$observer = new MutationObserver($5599ea74f46bbff6$var$onMutate);
var $5599ea74f46bbff6$var$currentlyObserving = false;
function $5599ea74f46bbff6$var$startObservingMutations() {
    $5599ea74f46bbff6$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $5599ea74f46bbff6$var$currentlyObserving = true;
}
function $5599ea74f46bbff6$var$stopObservingMutations() {
    $5599ea74f46bbff6$var$flushObserver();
    $5599ea74f46bbff6$var$observer.disconnect();
    $5599ea74f46bbff6$var$currentlyObserving = false;
}
var $5599ea74f46bbff6$var$queuedMutations = [];
function $5599ea74f46bbff6$var$flushObserver() {
    let records = $5599ea74f46bbff6$var$observer.takeRecords();
    $5599ea74f46bbff6$var$queuedMutations.push(()=>records.length > 0 && $5599ea74f46bbff6$var$onMutate(records));
    let queueLengthWhenTriggered = $5599ea74f46bbff6$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($5599ea74f46bbff6$var$queuedMutations.length === queueLengthWhenTriggered) while($5599ea74f46bbff6$var$queuedMutations.length > 0)$5599ea74f46bbff6$var$queuedMutations.shift()();
    });
}
function $5599ea74f46bbff6$var$mutateDom(callback) {
    if (!$5599ea74f46bbff6$var$currentlyObserving) return callback();
    $5599ea74f46bbff6$var$stopObservingMutations();
    let result = callback();
    $5599ea74f46bbff6$var$startObservingMutations();
    return result;
}
var $5599ea74f46bbff6$var$isCollecting = false;
var $5599ea74f46bbff6$var$deferredMutations = [];
function $5599ea74f46bbff6$var$deferMutations() {
    $5599ea74f46bbff6$var$isCollecting = true;
}
function $5599ea74f46bbff6$var$flushAndStopDeferringMutations() {
    $5599ea74f46bbff6$var$isCollecting = false;
    $5599ea74f46bbff6$var$onMutate($5599ea74f46bbff6$var$deferredMutations);
    $5599ea74f46bbff6$var$deferredMutations = [];
}
function $5599ea74f46bbff6$var$onMutate(mutations) {
    if ($5599ea74f46bbff6$var$isCollecting) {
        $5599ea74f46bbff6$var$deferredMutations = $5599ea74f46bbff6$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $5599ea74f46bbff6$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $5599ea74f46bbff6$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $5599ea74f46bbff6$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $5599ea74f46bbff6$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $5599ea74f46bbff6$var$scope(node) {
    return $5599ea74f46bbff6$var$mergeProxies($5599ea74f46bbff6$var$closestDataStack(node));
}
function $5599ea74f46bbff6$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$5599ea74f46bbff6$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $5599ea74f46bbff6$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $5599ea74f46bbff6$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $5599ea74f46bbff6$var$closestDataStack(node.parentNode);
}
function $5599ea74f46bbff6$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $5599ea74f46bbff6$var$mergeProxyTrap);
}
function $5599ea74f46bbff6$var$keyInPrototypeChain(obj, key) {
    if (obj === null || obj === Object.prototype) return null;
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj;
    return $5599ea74f46bbff6$var$keyInPrototypeChain(Object.getPrototypeOf(obj), key);
}
var $5599ea74f46bbff6$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $5599ea74f46bbff6$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        let target;
        for (const obj of objects){
            target = $5599ea74f46bbff6$var$keyInPrototypeChain(obj, name);
            if (target) break;
        }
        if (!target) target = objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $5599ea74f46bbff6$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $5599ea74f46bbff6$var$initInterceptors(data2) {
    let isObject3 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject3(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $5599ea74f46bbff6$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$5599ea74f46bbff6$var$get(data2, path), (value)=>$5599ea74f46bbff6$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $5599ea74f46bbff6$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $5599ea74f46bbff6$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $5599ea74f46bbff6$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $5599ea74f46bbff6$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $5599ea74f46bbff6$var$magics = {};
function $5599ea74f46bbff6$var$magic(name, callback) {
    $5599ea74f46bbff6$var$magics[name] = callback;
}
function $5599ea74f46bbff6$var$injectMagics(obj, el) {
    let memoizedUtilities = $5599ea74f46bbff6$var$getUtilities(el);
    Object.entries($5599ea74f46bbff6$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $5599ea74f46bbff6$var$getUtilities(el) {
    let [utilities, cleanup2] = $5599ea74f46bbff6$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $5599ea74f46bbff6$var$interceptor,
        ...utilities
    };
    $5599ea74f46bbff6$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $5599ea74f46bbff6$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $5599ea74f46bbff6$var$handleError(e, el, expression);
    }
}
function $5599ea74f46bbff6$var$handleError(...args) {
    return $5599ea74f46bbff6$var$errorHandler(...args);
}
var $5599ea74f46bbff6$var$errorHandler = $5599ea74f46bbff6$var$normalErrorHandler;
function $5599ea74f46bbff6$var$setErrorHandler(handler4) {
    $5599ea74f46bbff6$var$errorHandler = handler4;
}
function $5599ea74f46bbff6$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $5599ea74f46bbff6$var$shouldAutoEvaluateFunctions = true;
function $5599ea74f46bbff6$var$dontAutoEvaluateFunctions(callback) {
    let cache = $5599ea74f46bbff6$var$shouldAutoEvaluateFunctions;
    $5599ea74f46bbff6$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $5599ea74f46bbff6$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $5599ea74f46bbff6$var$evaluate(el, expression, extras = {}) {
    let result;
    $5599ea74f46bbff6$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $5599ea74f46bbff6$var$evaluateLater(...args) {
    return $5599ea74f46bbff6$var$theEvaluatorFunction(...args);
}
var $5599ea74f46bbff6$var$theEvaluatorFunction = ()=>{};
function $5599ea74f46bbff6$var$setEvaluator(newEvaluator) {
    $5599ea74f46bbff6$var$theEvaluatorFunction = newEvaluator;
}
var $5599ea74f46bbff6$var$theRawEvaluatorFunction;
function $5599ea74f46bbff6$var$setRawEvaluator(newEvaluator) {
    $5599ea74f46bbff6$var$theRawEvaluatorFunction = newEvaluator;
}
function $5599ea74f46bbff6$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $5599ea74f46bbff6$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$5599ea74f46bbff6$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $5599ea74f46bbff6$var$generateEvaluatorFromFunction(dataStack, expression) : $5599ea74f46bbff6$var$generateEvaluatorFromString(dataStack, expression, el);
    return $5599ea74f46bbff6$var$tryCatch.bind(null, el, expression, evaluator);
}
function $5599ea74f46bbff6$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$5599ea74f46bbff6$var$shouldAutoEvaluateFunctions) {
            $5599ea74f46bbff6$var$runIfTypeOfFunction(receiver, func, $5599ea74f46bbff6$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($5599ea74f46bbff6$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $5599ea74f46bbff6$var$runIfTypeOfFunction(receiver, result);
    };
}
var $5599ea74f46bbff6$var$evaluatorMemo = {};
function $5599ea74f46bbff6$var$generateFunctionFromString(expression, el) {
    if ($5599ea74f46bbff6$var$evaluatorMemo[expression]) return $5599ea74f46bbff6$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $5599ea74f46bbff6$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $5599ea74f46bbff6$var$evaluatorMemo[expression] = func;
    return func;
}
function $5599ea74f46bbff6$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $5599ea74f46bbff6$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $5599ea74f46bbff6$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$5599ea74f46bbff6$var$handleError(error2, el, expression));
            if (func.finished) {
                $5599ea74f46bbff6$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $5599ea74f46bbff6$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$5599ea74f46bbff6$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $5599ea74f46bbff6$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($5599ea74f46bbff6$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$5599ea74f46bbff6$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$5599ea74f46bbff6$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $5599ea74f46bbff6$var$evaluateRaw(...args) {
    return $5599ea74f46bbff6$var$theRawEvaluatorFunction(...args);
}
function $5599ea74f46bbff6$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $5599ea74f46bbff6$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$5599ea74f46bbff6$var$closestDataStack(el)
    ];
    let scope2 = $5599ea74f46bbff6$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $5599ea74f46bbff6$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $5599ea74f46bbff6$var$prefixAsString = "x-";
function $5599ea74f46bbff6$var$prefix(subject = "") {
    return $5599ea74f46bbff6$var$prefixAsString + subject;
}
function $5599ea74f46bbff6$var$setPrefix(newPrefix) {
    $5599ea74f46bbff6$var$prefixAsString = newPrefix;
}
var $5599ea74f46bbff6$var$directiveHandlers = {};
function $5599ea74f46bbff6$var$directive(name, callback) {
    $5599ea74f46bbff6$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$5599ea74f46bbff6$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $5599ea74f46bbff6$var$directiveOrder.indexOf(directive2);
            $5599ea74f46bbff6$var$directiveOrder.splice(pos >= 0 ? pos : $5599ea74f46bbff6$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $5599ea74f46bbff6$var$directiveExists(name) {
    return Object.keys($5599ea74f46bbff6$var$directiveHandlers).includes(name);
}
function $5599ea74f46bbff6$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $5599ea74f46bbff6$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($5599ea74f46bbff6$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($5599ea74f46bbff6$var$outNonAlpineAttributes).map($5599ea74f46bbff6$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($5599ea74f46bbff6$var$byPriority);
    return directives2.map((directive2)=>{
        return $5599ea74f46bbff6$var$getDirectiveHandler(el, directive2);
    });
}
function $5599ea74f46bbff6$var$attributesOnly(attributes) {
    return Array.from(attributes).map($5599ea74f46bbff6$var$toTransformedAttributes()).filter((attr)=>!$5599ea74f46bbff6$var$outNonAlpineAttributes(attr));
}
var $5599ea74f46bbff6$var$isDeferringHandlers = false;
var $5599ea74f46bbff6$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $5599ea74f46bbff6$var$currentHandlerStackKey = Symbol();
function $5599ea74f46bbff6$var$deferHandlingDirectives(callback) {
    $5599ea74f46bbff6$var$isDeferringHandlers = true;
    let key = Symbol();
    $5599ea74f46bbff6$var$currentHandlerStackKey = key;
    $5599ea74f46bbff6$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($5599ea74f46bbff6$var$directiveHandlerStacks.get(key).length)$5599ea74f46bbff6$var$directiveHandlerStacks.get(key).shift()();
        $5599ea74f46bbff6$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $5599ea74f46bbff6$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $5599ea74f46bbff6$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $5599ea74f46bbff6$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $5599ea74f46bbff6$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $5599ea74f46bbff6$var$evaluateLater.bind($5599ea74f46bbff6$var$evaluateLater, el),
        evaluate: $5599ea74f46bbff6$var$evaluate.bind($5599ea74f46bbff6$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $5599ea74f46bbff6$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $5599ea74f46bbff6$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $5599ea74f46bbff6$var$getElementBoundUtilities(el);
    $5599ea74f46bbff6$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $5599ea74f46bbff6$var$isDeferringHandlers ? $5599ea74f46bbff6$var$directiveHandlerStacks.get($5599ea74f46bbff6$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $5599ea74f46bbff6$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $5599ea74f46bbff6$var$into = (i)=>i;
function $5599ea74f46bbff6$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $5599ea74f46bbff6$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $5599ea74f46bbff6$var$attributeTransformers = [];
function $5599ea74f46bbff6$var$mapAttributes(callback) {
    $5599ea74f46bbff6$var$attributeTransformers.push(callback);
}
function $5599ea74f46bbff6$var$outNonAlpineAttributes({ name: name }) {
    return $5599ea74f46bbff6$var$alpineAttributeRegex().test(name);
}
var $5599ea74f46bbff6$var$alpineAttributeRegex = ()=>new RegExp(`^${$5599ea74f46bbff6$var$prefixAsString}([^:^.]+)\\b`);
function $5599ea74f46bbff6$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($5599ea74f46bbff6$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $5599ea74f46bbff6$var$DEFAULT = "DEFAULT";
var $5599ea74f46bbff6$var$directiveOrder = [
    "ignore",
    "ref",
    "id",
    "data",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $5599ea74f46bbff6$var$DEFAULT,
    "teleport"
];
function $5599ea74f46bbff6$var$byPriority(a, b) {
    let typeA = $5599ea74f46bbff6$var$directiveOrder.indexOf(a.type) === -1 ? $5599ea74f46bbff6$var$DEFAULT : a.type;
    let typeB = $5599ea74f46bbff6$var$directiveOrder.indexOf(b.type) === -1 ? $5599ea74f46bbff6$var$DEFAULT : b.type;
    return $5599ea74f46bbff6$var$directiveOrder.indexOf(typeA) - $5599ea74f46bbff6$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $5599ea74f46bbff6$var$dispatch(el, name, detail = {}, options = {}) {
    return el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true,
        // Allows overriding the default event options.
        ...options
    }));
}
// packages/alpinejs/src/utils/walk.js
function $5599ea74f46bbff6$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$5599ea74f46bbff6$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $5599ea74f46bbff6$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $5599ea74f46bbff6$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $5599ea74f46bbff6$var$started = false;
function $5599ea74f46bbff6$var$start() {
    if ($5599ea74f46bbff6$var$started) $5599ea74f46bbff6$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $5599ea74f46bbff6$var$started = true;
    if (!document.body) $5599ea74f46bbff6$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $5599ea74f46bbff6$var$dispatch(document, "alpine:init");
    $5599ea74f46bbff6$var$dispatch(document, "alpine:initializing");
    $5599ea74f46bbff6$var$startObservingMutations();
    $5599ea74f46bbff6$var$onElAdded((el)=>$5599ea74f46bbff6$var$initTree(el, $5599ea74f46bbff6$var$walk));
    $5599ea74f46bbff6$var$onElRemoved((el)=>$5599ea74f46bbff6$var$destroyTree(el));
    $5599ea74f46bbff6$var$onAttributesAdded((el, attrs)=>{
        $5599ea74f46bbff6$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$5599ea74f46bbff6$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($5599ea74f46bbff6$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $5599ea74f46bbff6$var$initTree(el);
    });
    $5599ea74f46bbff6$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $5599ea74f46bbff6$var$warnAboutMissingPlugins();
    });
}
var $5599ea74f46bbff6$var$rootSelectorCallbacks = [];
var $5599ea74f46bbff6$var$initSelectorCallbacks = [];
function $5599ea74f46bbff6$var$rootSelectors() {
    return $5599ea74f46bbff6$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $5599ea74f46bbff6$var$allSelectors() {
    return $5599ea74f46bbff6$var$rootSelectorCallbacks.concat($5599ea74f46bbff6$var$initSelectorCallbacks).map((fn)=>fn());
}
function $5599ea74f46bbff6$var$addRootSelector(selectorCallback) {
    $5599ea74f46bbff6$var$rootSelectorCallbacks.push(selectorCallback);
}
function $5599ea74f46bbff6$var$addInitSelector(selectorCallback) {
    $5599ea74f46bbff6$var$initSelectorCallbacks.push(selectorCallback);
}
function $5599ea74f46bbff6$var$closestRoot(el, includeInitSelectors = false) {
    return $5599ea74f46bbff6$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $5599ea74f46bbff6$var$allSelectors() : $5599ea74f46bbff6$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $5599ea74f46bbff6$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) return $5599ea74f46bbff6$var$findClosest(el._x_teleportBack, callback);
    if (el.parentNode instanceof ShadowRoot) return $5599ea74f46bbff6$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $5599ea74f46bbff6$var$findClosest(el.parentElement, callback);
}
function $5599ea74f46bbff6$var$isRoot(el) {
    return $5599ea74f46bbff6$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $5599ea74f46bbff6$var$initInterceptors2 = [];
function $5599ea74f46bbff6$var$interceptInit(callback) {
    $5599ea74f46bbff6$var$initInterceptors2.push(callback);
}
var $5599ea74f46bbff6$var$markerDispenser = 1;
function $5599ea74f46bbff6$var$initTree(el, walker = $5599ea74f46bbff6$var$walk, intercept = ()=>{}) {
    if ($5599ea74f46bbff6$var$findClosest(el, (i)=>i._x_ignore)) return;
    $5599ea74f46bbff6$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $5599ea74f46bbff6$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $5599ea74f46bbff6$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $5599ea74f46bbff6$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $5599ea74f46bbff6$var$destroyTree(root, walker = $5599ea74f46bbff6$var$walk) {
    walker(root, (el)=>{
        $5599ea74f46bbff6$var$cleanupElement(el);
        $5599ea74f46bbff6$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $5599ea74f46bbff6$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($5599ea74f46bbff6$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $5599ea74f46bbff6$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $5599ea74f46bbff6$var$tickStack = [];
var $5599ea74f46bbff6$var$isHolding = false;
function $5599ea74f46bbff6$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $5599ea74f46bbff6$var$isHolding || setTimeout(()=>{
            $5599ea74f46bbff6$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $5599ea74f46bbff6$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $5599ea74f46bbff6$var$releaseNextTicks() {
    $5599ea74f46bbff6$var$isHolding = false;
    while($5599ea74f46bbff6$var$tickStack.length)$5599ea74f46bbff6$var$tickStack.shift()();
}
function $5599ea74f46bbff6$var$holdNextTicks() {
    $5599ea74f46bbff6$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $5599ea74f46bbff6$var$setClasses(el, value) {
    if (Array.isArray(value)) return $5599ea74f46bbff6$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $5599ea74f46bbff6$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $5599ea74f46bbff6$var$setClasses(el, value());
    return $5599ea74f46bbff6$var$setClassesFromString(el, value);
}
function $5599ea74f46bbff6$var$splitClasses(classString) {
    return classString.split(/\s/).filter(Boolean);
}
function $5599ea74f46bbff6$var$setClassesFromString(el, classString) {
    let missingClasses = (classString2)=>$5599ea74f46bbff6$var$splitClasses(classString2).filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $5599ea74f46bbff6$var$setClassesFromObject(el, classObject) {
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? $5599ea74f46bbff6$var$splitClasses(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? $5599ea74f46bbff6$var$splitClasses(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $5599ea74f46bbff6$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $5599ea74f46bbff6$var$setStylesFromObject(el, value);
    return $5599ea74f46bbff6$var$setStylesFromString(el, value);
}
function $5599ea74f46bbff6$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $5599ea74f46bbff6$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $5599ea74f46bbff6$var$setStyles(el, previousStyles);
    };
}
function $5599ea74f46bbff6$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $5599ea74f46bbff6$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $5599ea74f46bbff6$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$5599ea74f46bbff6$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $5599ea74f46bbff6$var$registerTransitionsFromHelper(el, modifiers, value);
    else $5599ea74f46bbff6$var$registerTransitionsFromClassString(el, expression, value);
});
function $5599ea74f46bbff6$var$registerTransitionsFromClassString(el, classString, stage) {
    $5599ea74f46bbff6$var$registerTransitionObject(el, $5599ea74f46bbff6$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $5599ea74f46bbff6$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $5599ea74f46bbff6$var$registerTransitionObject(el, $5599ea74f46bbff6$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $5599ea74f46bbff6$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $5599ea74f46bbff6$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $5599ea74f46bbff6$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $5599ea74f46bbff6$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $5599ea74f46bbff6$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $5599ea74f46bbff6$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $5599ea74f46bbff6$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $5599ea74f46bbff6$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $5599ea74f46bbff6$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $5599ea74f46bbff6$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $5599ea74f46bbff6$var$closestHide(parent);
}
function $5599ea74f46bbff6$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $5599ea74f46bbff6$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $5599ea74f46bbff6$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $5599ea74f46bbff6$var$once(()=>{
        $5599ea74f46bbff6$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $5599ea74f46bbff6$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $5599ea74f46bbff6$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $5599ea74f46bbff6$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $5599ea74f46bbff6$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $5599ea74f46bbff6$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $5599ea74f46bbff6$var$mutateDom(()=>{
                stages.end();
            });
            $5599ea74f46bbff6$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $5599ea74f46bbff6$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $5599ea74f46bbff6$var$isCloning = false;
function $5599ea74f46bbff6$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$5599ea74f46bbff6$var$isCloning ? fallback(...args) : callback(...args);
}
function $5599ea74f46bbff6$var$onlyDuringClone(callback) {
    return (...args)=>$5599ea74f46bbff6$var$isCloning && callback(...args);
}
var $5599ea74f46bbff6$var$interceptors = [];
function $5599ea74f46bbff6$var$interceptClone(callback) {
    $5599ea74f46bbff6$var$interceptors.push(callback);
}
function $5599ea74f46bbff6$var$cloneNode(from, to) {
    $5599ea74f46bbff6$var$interceptors.forEach((i)=>i(from, to));
    $5599ea74f46bbff6$var$isCloning = true;
    $5599ea74f46bbff6$var$dontRegisterReactiveSideEffects(()=>{
        $5599ea74f46bbff6$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $5599ea74f46bbff6$var$isCloning = false;
}
var $5599ea74f46bbff6$var$isCloningLegacy = false;
function $5599ea74f46bbff6$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $5599ea74f46bbff6$var$isCloning = true;
    $5599ea74f46bbff6$var$isCloningLegacy = true;
    $5599ea74f46bbff6$var$dontRegisterReactiveSideEffects(()=>{
        $5599ea74f46bbff6$var$cloneTree(newEl);
    });
    $5599ea74f46bbff6$var$isCloning = false;
    $5599ea74f46bbff6$var$isCloningLegacy = false;
}
function $5599ea74f46bbff6$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $5599ea74f46bbff6$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $5599ea74f46bbff6$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $5599ea74f46bbff6$var$initTree(el, shallowWalker);
}
function $5599ea74f46bbff6$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $5599ea74f46bbff6$var$effect;
    $5599ea74f46bbff6$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $5599ea74f46bbff6$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $5599ea74f46bbff6$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $5599ea74f46bbff6$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $5599ea74f46bbff6$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $5599ea74f46bbff6$var$camelCase(name) : name;
    switch(name){
        case "value":
            $5599ea74f46bbff6$var$bindInputValue(el, value);
            break;
        case "style":
            $5599ea74f46bbff6$var$bindStyles(el, value);
            break;
        case "class":
            $5599ea74f46bbff6$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $5599ea74f46bbff6$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $5599ea74f46bbff6$var$bindAttribute(el, name, value);
            break;
    }
}
function $5599ea74f46bbff6$var$bindInputValue(el, value) {
    if ($5599ea74f46bbff6$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
    } else if ($5599ea74f46bbff6$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$5599ea74f46bbff6$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $5599ea74f46bbff6$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $5599ea74f46bbff6$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $5599ea74f46bbff6$var$setClasses(el, value);
}
function $5599ea74f46bbff6$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $5599ea74f46bbff6$var$setStyles(el, value);
}
function $5599ea74f46bbff6$var$bindAttributeAndProperty(el, name, value) {
    $5599ea74f46bbff6$var$bindAttribute(el, name, value);
    $5599ea74f46bbff6$var$setPropertyIfChanged(el, name, value);
}
function $5599ea74f46bbff6$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $5599ea74f46bbff6$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($5599ea74f46bbff6$var$isBooleanAttr(name)) value = name;
        $5599ea74f46bbff6$var$setIfChanged(el, name, value);
    }
}
function $5599ea74f46bbff6$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $5599ea74f46bbff6$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $5599ea74f46bbff6$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $5599ea74f46bbff6$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $5599ea74f46bbff6$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $5599ea74f46bbff6$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $5599ea74f46bbff6$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $5599ea74f46bbff6$var$isBooleanAttr(attrName) {
    return $5599ea74f46bbff6$var$booleanAttributes.has(attrName);
}
function $5599ea74f46bbff6$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $5599ea74f46bbff6$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $5599ea74f46bbff6$var$getAttributeBinding(el, name, fallback);
}
function $5599ea74f46bbff6$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $5599ea74f46bbff6$var$dontAutoEvaluateFunctions(()=>{
            return $5599ea74f46bbff6$var$evaluate(el, binding.expression);
        });
    }
    return $5599ea74f46bbff6$var$getAttributeBinding(el, name, fallback);
}
function $5599ea74f46bbff6$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($5599ea74f46bbff6$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $5599ea74f46bbff6$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $5599ea74f46bbff6$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $5599ea74f46bbff6$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $5599ea74f46bbff6$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $5599ea74f46bbff6$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $5599ea74f46bbff6$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($5599ea74f46bbff6$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($5599ea74f46bbff6$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($5599ea74f46bbff6$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $5599ea74f46bbff6$var$release(reference);
    };
}
function $5599ea74f46bbff6$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $5599ea74f46bbff6$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($5599ea74f46bbff6$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $5599ea74f46bbff6$var$stores = {};
var $5599ea74f46bbff6$var$isReactive = false;
function $5599ea74f46bbff6$var$store(name, value) {
    if (!$5599ea74f46bbff6$var$isReactive) {
        $5599ea74f46bbff6$var$stores = $5599ea74f46bbff6$var$reactive($5599ea74f46bbff6$var$stores);
        $5599ea74f46bbff6$var$isReactive = true;
    }
    if (value === void 0) return $5599ea74f46bbff6$var$stores[name];
    $5599ea74f46bbff6$var$stores[name] = value;
    $5599ea74f46bbff6$var$initInterceptors($5599ea74f46bbff6$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $5599ea74f46bbff6$var$stores[name].init();
}
function $5599ea74f46bbff6$var$getStores() {
    return $5599ea74f46bbff6$var$stores;
}
// packages/alpinejs/src/binds.js
var $5599ea74f46bbff6$var$binds = {};
function $5599ea74f46bbff6$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $5599ea74f46bbff6$var$applyBindingsObject(name, getBindings());
    else $5599ea74f46bbff6$var$binds[name] = getBindings;
    return ()=>{};
}
function $5599ea74f46bbff6$var$injectBindingProviders(obj) {
    Object.entries($5599ea74f46bbff6$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $5599ea74f46bbff6$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $5599ea74f46bbff6$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $5599ea74f46bbff6$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $5599ea74f46bbff6$var$datas = {};
function $5599ea74f46bbff6$var$data(name, callback) {
    $5599ea74f46bbff6$var$datas[name] = callback;
}
function $5599ea74f46bbff6$var$injectDataProviders(obj, context) {
    Object.entries($5599ea74f46bbff6$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $5599ea74f46bbff6$var$Alpine = {
    get reactive () {
        return $5599ea74f46bbff6$var$reactive;
    },
    get release () {
        return $5599ea74f46bbff6$var$release;
    },
    get effect () {
        return $5599ea74f46bbff6$var$effect;
    },
    get raw () {
        return $5599ea74f46bbff6$var$raw;
    },
    get transaction () {
        return $5599ea74f46bbff6$var$transaction;
    },
    version: "3.15.12",
    flushAndStopDeferringMutations: $5599ea74f46bbff6$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $5599ea74f46bbff6$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $5599ea74f46bbff6$var$disableEffectScheduling,
    startObservingMutations: $5599ea74f46bbff6$var$startObservingMutations,
    stopObservingMutations: $5599ea74f46bbff6$var$stopObservingMutations,
    setReactivityEngine: $5599ea74f46bbff6$var$setReactivityEngine,
    onAttributeRemoved: $5599ea74f46bbff6$var$onAttributeRemoved,
    onAttributesAdded: $5599ea74f46bbff6$var$onAttributesAdded,
    closestDataStack: $5599ea74f46bbff6$var$closestDataStack,
    skipDuringClone: $5599ea74f46bbff6$var$skipDuringClone,
    onlyDuringClone: $5599ea74f46bbff6$var$onlyDuringClone,
    addRootSelector: $5599ea74f46bbff6$var$addRootSelector,
    addInitSelector: $5599ea74f46bbff6$var$addInitSelector,
    setErrorHandler: $5599ea74f46bbff6$var$setErrorHandler,
    interceptClone: $5599ea74f46bbff6$var$interceptClone,
    addScopeToNode: $5599ea74f46bbff6$var$addScopeToNode,
    deferMutations: $5599ea74f46bbff6$var$deferMutations,
    mapAttributes: $5599ea74f46bbff6$var$mapAttributes,
    evaluateLater: $5599ea74f46bbff6$var$evaluateLater,
    interceptInit: $5599ea74f46bbff6$var$interceptInit,
    initInterceptors: $5599ea74f46bbff6$var$initInterceptors,
    injectMagics: $5599ea74f46bbff6$var$injectMagics,
    setEvaluator: $5599ea74f46bbff6$var$setEvaluator,
    setRawEvaluator: $5599ea74f46bbff6$var$setRawEvaluator,
    mergeProxies: $5599ea74f46bbff6$var$mergeProxies,
    extractProp: $5599ea74f46bbff6$var$extractProp,
    findClosest: $5599ea74f46bbff6$var$findClosest,
    onElRemoved: $5599ea74f46bbff6$var$onElRemoved,
    closestRoot: $5599ea74f46bbff6$var$closestRoot,
    destroyTree: $5599ea74f46bbff6$var$destroyTree,
    interceptor: $5599ea74f46bbff6$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $5599ea74f46bbff6$var$transition,
    setStyles: // INTERNAL
    $5599ea74f46bbff6$var$setStyles,
    mutateDom: // INTERNAL
    $5599ea74f46bbff6$var$mutateDom,
    directive: $5599ea74f46bbff6$var$directive,
    entangle: $5599ea74f46bbff6$var$entangle,
    throttle: $5599ea74f46bbff6$var$throttle,
    debounce: $5599ea74f46bbff6$var$debounce,
    evaluate: $5599ea74f46bbff6$var$evaluate,
    evaluateRaw: $5599ea74f46bbff6$var$evaluateRaw,
    initTree: $5599ea74f46bbff6$var$initTree,
    nextTick: $5599ea74f46bbff6$var$nextTick,
    prefixed: $5599ea74f46bbff6$var$prefix,
    prefix: $5599ea74f46bbff6$var$setPrefix,
    plugin: $5599ea74f46bbff6$var$plugin,
    magic: $5599ea74f46bbff6$var$magic,
    store: $5599ea74f46bbff6$var$store,
    start: $5599ea74f46bbff6$var$start,
    clone: $5599ea74f46bbff6$var$clone,
    cloneNode: // INTERNAL
    $5599ea74f46bbff6$var$cloneNode,
    // INTERNAL
    bound: $5599ea74f46bbff6$var$getBinding,
    $data: $5599ea74f46bbff6$var$scope,
    watch: $5599ea74f46bbff6$var$watch,
    walk: $5599ea74f46bbff6$var$walk,
    data: $5599ea74f46bbff6$var$data,
    bind: $5599ea74f46bbff6$var$bind2
};
var $5599ea74f46bbff6$var$alpine_default = $5599ea74f46bbff6$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $5599ea74f46bbff6$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $5599ea74f46bbff6$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $5599ea74f46bbff6$var$isBooleanAttr2 = /* @__PURE__ */ $5599ea74f46bbff6$var$makeMap($5599ea74f46bbff6$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $5599ea74f46bbff6$var$EMPTY_OBJ = Object.freeze({});
var $5599ea74f46bbff6$var$EMPTY_ARR = Object.freeze([]);
var $5599ea74f46bbff6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5599ea74f46bbff6$var$hasOwn = (val, key)=>$5599ea74f46bbff6$var$hasOwnProperty.call(val, key);
var $5599ea74f46bbff6$var$isArray = Array.isArray;
var $5599ea74f46bbff6$var$isMap = (val)=>$5599ea74f46bbff6$var$toTypeString(val) === "[object Map]";
var $5599ea74f46bbff6$var$isString = (val)=>typeof val === "string";
var $5599ea74f46bbff6$var$isSymbol = (val)=>typeof val === "symbol";
var $5599ea74f46bbff6$var$isObject = (val)=>val !== null && typeof val === "object";
var $5599ea74f46bbff6$var$objectToString = Object.prototype.toString;
var $5599ea74f46bbff6$var$toTypeString = (value)=>$5599ea74f46bbff6$var$objectToString.call(value);
var $5599ea74f46bbff6$var$toRawType = (value)=>{
    return $5599ea74f46bbff6$var$toTypeString(value).slice(8, -1);
};
var $5599ea74f46bbff6$var$isIntegerKey = (key)=>$5599ea74f46bbff6$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $5599ea74f46bbff6$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $5599ea74f46bbff6$var$camelizeRE = /-(\w)/g;
var $5599ea74f46bbff6$var$camelize = $5599ea74f46bbff6$var$cacheStringFunction((str)=>{
    return str.replace($5599ea74f46bbff6$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $5599ea74f46bbff6$var$hyphenateRE = /\B([A-Z])/g;
var $5599ea74f46bbff6$var$hyphenate = $5599ea74f46bbff6$var$cacheStringFunction((str)=>str.replace($5599ea74f46bbff6$var$hyphenateRE, "-$1").toLowerCase());
var $5599ea74f46bbff6$var$capitalize = $5599ea74f46bbff6$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $5599ea74f46bbff6$var$toHandlerKey = $5599ea74f46bbff6$var$cacheStringFunction((str)=>str ? `on${$5599ea74f46bbff6$var$capitalize(str)}` : ``);
var $5599ea74f46bbff6$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $5599ea74f46bbff6$var$targetMap = /* @__PURE__ */ new WeakMap();
var $5599ea74f46bbff6$var$effectStack = [];
var $5599ea74f46bbff6$var$activeEffect;
var $5599ea74f46bbff6$var$ITERATE_KEY = Symbol("iterate");
var $5599ea74f46bbff6$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $5599ea74f46bbff6$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $5599ea74f46bbff6$var$effect2(fn, options = $5599ea74f46bbff6$var$EMPTY_OBJ) {
    if ($5599ea74f46bbff6$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $5599ea74f46bbff6$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $5599ea74f46bbff6$var$stop(effect3) {
    if (effect3.active) {
        $5599ea74f46bbff6$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $5599ea74f46bbff6$var$uid = 0;
function $5599ea74f46bbff6$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$5599ea74f46bbff6$var$effectStack.includes(effect3)) {
            $5599ea74f46bbff6$var$cleanup(effect3);
            try {
                $5599ea74f46bbff6$var$enableTracking();
                $5599ea74f46bbff6$var$effectStack.push(effect3);
                $5599ea74f46bbff6$var$activeEffect = effect3;
                return fn();
            } finally{
                $5599ea74f46bbff6$var$effectStack.pop();
                $5599ea74f46bbff6$var$resetTracking();
                $5599ea74f46bbff6$var$activeEffect = $5599ea74f46bbff6$var$effectStack[$5599ea74f46bbff6$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $5599ea74f46bbff6$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $5599ea74f46bbff6$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $5599ea74f46bbff6$var$shouldTrack = true;
var $5599ea74f46bbff6$var$trackStack = [];
function $5599ea74f46bbff6$var$pauseTracking() {
    $5599ea74f46bbff6$var$trackStack.push($5599ea74f46bbff6$var$shouldTrack);
    $5599ea74f46bbff6$var$shouldTrack = false;
}
function $5599ea74f46bbff6$var$enableTracking() {
    $5599ea74f46bbff6$var$trackStack.push($5599ea74f46bbff6$var$shouldTrack);
    $5599ea74f46bbff6$var$shouldTrack = true;
}
function $5599ea74f46bbff6$var$resetTracking() {
    const last = $5599ea74f46bbff6$var$trackStack.pop();
    $5599ea74f46bbff6$var$shouldTrack = last === void 0 ? true : last;
}
function $5599ea74f46bbff6$var$track(target, type, key) {
    if (!$5599ea74f46bbff6$var$shouldTrack || $5599ea74f46bbff6$var$activeEffect === void 0) return;
    let depsMap = $5599ea74f46bbff6$var$targetMap.get(target);
    if (!depsMap) $5599ea74f46bbff6$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($5599ea74f46bbff6$var$activeEffect)) {
        dep.add($5599ea74f46bbff6$var$activeEffect);
        $5599ea74f46bbff6$var$activeEffect.deps.push(dep);
        if ($5599ea74f46bbff6$var$activeEffect.options.onTrack) $5599ea74f46bbff6$var$activeEffect.options.onTrack({
            effect: $5599ea74f46bbff6$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $5599ea74f46bbff6$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $5599ea74f46bbff6$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $5599ea74f46bbff6$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $5599ea74f46bbff6$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$5599ea74f46bbff6$var$isArray(target)) {
                    add2(depsMap.get($5599ea74f46bbff6$var$ITERATE_KEY));
                    if ($5599ea74f46bbff6$var$isMap(target)) add2(depsMap.get($5599ea74f46bbff6$var$MAP_KEY_ITERATE_KEY));
                } else if ($5599ea74f46bbff6$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$5599ea74f46bbff6$var$isArray(target)) {
                    add2(depsMap.get($5599ea74f46bbff6$var$ITERATE_KEY));
                    if ($5599ea74f46bbff6$var$isMap(target)) add2(depsMap.get($5599ea74f46bbff6$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($5599ea74f46bbff6$var$isMap(target)) add2(depsMap.get($5599ea74f46bbff6$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $5599ea74f46bbff6$var$isNonTrackableKeys = /* @__PURE__ */ $5599ea74f46bbff6$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $5599ea74f46bbff6$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($5599ea74f46bbff6$var$isSymbol));
var $5599ea74f46bbff6$var$get2 = /* @__PURE__ */ $5599ea74f46bbff6$var$createGetter();
var $5599ea74f46bbff6$var$readonlyGet = /* @__PURE__ */ $5599ea74f46bbff6$var$createGetter(true);
var $5599ea74f46bbff6$var$arrayInstrumentations = /* @__PURE__ */ $5599ea74f46bbff6$var$createArrayInstrumentations();
function $5599ea74f46bbff6$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $5599ea74f46bbff6$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$5599ea74f46bbff6$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($5599ea74f46bbff6$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $5599ea74f46bbff6$var$pauseTracking();
            const res = $5599ea74f46bbff6$var$toRaw(this)[key].apply(this, args);
            $5599ea74f46bbff6$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $5599ea74f46bbff6$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $5599ea74f46bbff6$var$shallowReadonlyMap : $5599ea74f46bbff6$var$readonlyMap : shallow ? $5599ea74f46bbff6$var$shallowReactiveMap : $5599ea74f46bbff6$var$reactiveMap).get(target)) return target;
        const targetIsArray = $5599ea74f46bbff6$var$isArray(target);
        if (!isReadonly && targetIsArray && $5599ea74f46bbff6$var$hasOwn($5599ea74f46bbff6$var$arrayInstrumentations, key)) return Reflect.get($5599ea74f46bbff6$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($5599ea74f46bbff6$var$isSymbol(key) ? $5599ea74f46bbff6$var$builtInSymbols.has(key) : $5599ea74f46bbff6$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $5599ea74f46bbff6$var$track(target, "get", key);
        if (shallow) return res;
        if ($5599ea74f46bbff6$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$5599ea74f46bbff6$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($5599ea74f46bbff6$var$isObject(res)) return isReadonly ? $5599ea74f46bbff6$var$readonly(res) : $5599ea74f46bbff6$var$reactive2(res);
        return res;
    };
}
var $5599ea74f46bbff6$var$set2 = /* @__PURE__ */ $5599ea74f46bbff6$var$createSetter();
function $5599ea74f46bbff6$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $5599ea74f46bbff6$var$toRaw(value);
            oldValue = $5599ea74f46bbff6$var$toRaw(oldValue);
            if (!$5599ea74f46bbff6$var$isArray(target) && $5599ea74f46bbff6$var$isRef(oldValue) && !$5599ea74f46bbff6$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $5599ea74f46bbff6$var$isArray(target) && $5599ea74f46bbff6$var$isIntegerKey(key) ? Number(key) < target.length : $5599ea74f46bbff6$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $5599ea74f46bbff6$var$toRaw(receiver)) {
            if (!hadKey) $5599ea74f46bbff6$var$trigger(target, "add", key, value);
            else if ($5599ea74f46bbff6$var$hasChanged(value, oldValue)) $5599ea74f46bbff6$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $5599ea74f46bbff6$var$deleteProperty(target, key) {
    const hadKey = $5599ea74f46bbff6$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $5599ea74f46bbff6$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $5599ea74f46bbff6$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$5599ea74f46bbff6$var$isSymbol(key) || !$5599ea74f46bbff6$var$builtInSymbols.has(key)) $5599ea74f46bbff6$var$track(target, "has", key);
    return result;
}
function $5599ea74f46bbff6$var$ownKeys(target) {
    $5599ea74f46bbff6$var$track(target, "iterate", $5599ea74f46bbff6$var$isArray(target) ? "length" : $5599ea74f46bbff6$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $5599ea74f46bbff6$var$mutableHandlers = {
    get: $5599ea74f46bbff6$var$get2,
    set: $5599ea74f46bbff6$var$set2,
    deleteProperty: $5599ea74f46bbff6$var$deleteProperty,
    has: $5599ea74f46bbff6$var$has,
    ownKeys: $5599ea74f46bbff6$var$ownKeys
};
var $5599ea74f46bbff6$var$readonlyHandlers = {
    get: $5599ea74f46bbff6$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $5599ea74f46bbff6$var$toReactive = (value)=>$5599ea74f46bbff6$var$isObject(value) ? $5599ea74f46bbff6$var$reactive2(value) : value;
var $5599ea74f46bbff6$var$toReadonly = (value)=>$5599ea74f46bbff6$var$isObject(value) ? $5599ea74f46bbff6$var$readonly(value) : value;
var $5599ea74f46bbff6$var$toShallow = (value)=>value;
var $5599ea74f46bbff6$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $5599ea74f46bbff6$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $5599ea74f46bbff6$var$toRaw(target);
    const rawKey = $5599ea74f46bbff6$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $5599ea74f46bbff6$var$track(rawTarget, "get", key);
    !isReadonly && $5599ea74f46bbff6$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $5599ea74f46bbff6$var$getProto(rawTarget);
    const wrap = isShallow ? $5599ea74f46bbff6$var$toShallow : isReadonly ? $5599ea74f46bbff6$var$toReadonly : $5599ea74f46bbff6$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $5599ea74f46bbff6$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $5599ea74f46bbff6$var$toRaw(target);
    const rawKey = $5599ea74f46bbff6$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $5599ea74f46bbff6$var$track(rawTarget, "has", key);
    !isReadonly && $5599ea74f46bbff6$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $5599ea74f46bbff6$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $5599ea74f46bbff6$var$track($5599ea74f46bbff6$var$toRaw(target), "iterate", $5599ea74f46bbff6$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $5599ea74f46bbff6$var$add(value) {
    value = $5599ea74f46bbff6$var$toRaw(value);
    const target = $5599ea74f46bbff6$var$toRaw(this);
    const proto = $5599ea74f46bbff6$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $5599ea74f46bbff6$var$trigger(target, "add", value, value);
    }
    return this;
}
function $5599ea74f46bbff6$var$set$1(key, value) {
    value = $5599ea74f46bbff6$var$toRaw(value);
    const target = $5599ea74f46bbff6$var$toRaw(this);
    const { has: has2, get: get3 } = $5599ea74f46bbff6$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $5599ea74f46bbff6$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $5599ea74f46bbff6$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $5599ea74f46bbff6$var$trigger(target, "add", key, value);
    else if ($5599ea74f46bbff6$var$hasChanged(value, oldValue)) $5599ea74f46bbff6$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $5599ea74f46bbff6$var$deleteEntry(key) {
    const target = $5599ea74f46bbff6$var$toRaw(this);
    const { has: has2, get: get3 } = $5599ea74f46bbff6$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $5599ea74f46bbff6$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $5599ea74f46bbff6$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $5599ea74f46bbff6$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $5599ea74f46bbff6$var$clear() {
    const target = $5599ea74f46bbff6$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $5599ea74f46bbff6$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $5599ea74f46bbff6$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $5599ea74f46bbff6$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $5599ea74f46bbff6$var$toRaw(target);
        const wrap = isShallow ? $5599ea74f46bbff6$var$toShallow : isReadonly ? $5599ea74f46bbff6$var$toReadonly : $5599ea74f46bbff6$var$toReactive;
        !isReadonly && $5599ea74f46bbff6$var$track(rawTarget, "iterate", $5599ea74f46bbff6$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $5599ea74f46bbff6$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $5599ea74f46bbff6$var$toRaw(target);
        const targetIsMap = $5599ea74f46bbff6$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $5599ea74f46bbff6$var$toShallow : isReadonly ? $5599ea74f46bbff6$var$toReadonly : $5599ea74f46bbff6$var$toReactive;
        !isReadonly && $5599ea74f46bbff6$var$track(rawTarget, "iterate", isKeyOnly ? $5599ea74f46bbff6$var$MAP_KEY_ITERATE_KEY : $5599ea74f46bbff6$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $5599ea74f46bbff6$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$5599ea74f46bbff6$var$capitalize(type)} operation ${key}failed: target is readonly.`, $5599ea74f46bbff6$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $5599ea74f46bbff6$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $5599ea74f46bbff6$var$get$1(this, key);
        },
        get size () {
            return $5599ea74f46bbff6$var$size(this);
        },
        has: $5599ea74f46bbff6$var$has$1,
        add: $5599ea74f46bbff6$var$add,
        set: $5599ea74f46bbff6$var$set$1,
        delete: $5599ea74f46bbff6$var$deleteEntry,
        clear: $5599ea74f46bbff6$var$clear,
        forEach: $5599ea74f46bbff6$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $5599ea74f46bbff6$var$get$1(this, key, false, true);
        },
        get size () {
            return $5599ea74f46bbff6$var$size(this);
        },
        has: $5599ea74f46bbff6$var$has$1,
        add: $5599ea74f46bbff6$var$add,
        set: $5599ea74f46bbff6$var$set$1,
        delete: $5599ea74f46bbff6$var$deleteEntry,
        clear: $5599ea74f46bbff6$var$clear,
        forEach: $5599ea74f46bbff6$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $5599ea74f46bbff6$var$get$1(this, key, true);
        },
        get size () {
            return $5599ea74f46bbff6$var$size(this, true);
        },
        has (key) {
            return $5599ea74f46bbff6$var$has$1.call(this, key, true);
        },
        add: $5599ea74f46bbff6$var$createReadonlyMethod("add"),
        set: $5599ea74f46bbff6$var$createReadonlyMethod("set"),
        delete: $5599ea74f46bbff6$var$createReadonlyMethod("delete"),
        clear: $5599ea74f46bbff6$var$createReadonlyMethod("clear"),
        forEach: $5599ea74f46bbff6$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $5599ea74f46bbff6$var$get$1(this, key, true, true);
        },
        get size () {
            return $5599ea74f46bbff6$var$size(this, true);
        },
        has (key) {
            return $5599ea74f46bbff6$var$has$1.call(this, key, true);
        },
        add: $5599ea74f46bbff6$var$createReadonlyMethod("add"),
        set: $5599ea74f46bbff6$var$createReadonlyMethod("set"),
        delete: $5599ea74f46bbff6$var$createReadonlyMethod("delete"),
        clear: $5599ea74f46bbff6$var$createReadonlyMethod("clear"),
        forEach: $5599ea74f46bbff6$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $5599ea74f46bbff6$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $5599ea74f46bbff6$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $5599ea74f46bbff6$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $5599ea74f46bbff6$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$5599ea74f46bbff6$var$mutableInstrumentations, $5599ea74f46bbff6$var$readonlyInstrumentations, $5599ea74f46bbff6$var$shallowInstrumentations, $5599ea74f46bbff6$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $5599ea74f46bbff6$var$createInstrumentations();
function $5599ea74f46bbff6$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $5599ea74f46bbff6$var$shallowReadonlyInstrumentations : $5599ea74f46bbff6$var$shallowInstrumentations : isReadonly ? $5599ea74f46bbff6$var$readonlyInstrumentations : $5599ea74f46bbff6$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($5599ea74f46bbff6$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $5599ea74f46bbff6$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $5599ea74f46bbff6$var$createInstrumentationGetter(false, false)
};
var $5599ea74f46bbff6$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $5599ea74f46bbff6$var$createInstrumentationGetter(true, false)
};
function $5599ea74f46bbff6$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $5599ea74f46bbff6$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $5599ea74f46bbff6$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $5599ea74f46bbff6$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $5599ea74f46bbff6$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $5599ea74f46bbff6$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $5599ea74f46bbff6$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $5599ea74f46bbff6$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $5599ea74f46bbff6$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $5599ea74f46bbff6$var$targetTypeMap($5599ea74f46bbff6$var$toRawType(value));
}
function $5599ea74f46bbff6$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $5599ea74f46bbff6$var$createReactiveObject(target, false, $5599ea74f46bbff6$var$mutableHandlers, $5599ea74f46bbff6$var$mutableCollectionHandlers, $5599ea74f46bbff6$var$reactiveMap);
}
function $5599ea74f46bbff6$var$readonly(target) {
    return $5599ea74f46bbff6$var$createReactiveObject(target, true, $5599ea74f46bbff6$var$readonlyHandlers, $5599ea74f46bbff6$var$readonlyCollectionHandlers, $5599ea74f46bbff6$var$readonlyMap);
}
function $5599ea74f46bbff6$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$5599ea74f46bbff6$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $5599ea74f46bbff6$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $5599ea74f46bbff6$var$toRaw(observed) {
    return observed && $5599ea74f46bbff6$var$toRaw(observed["__v_raw"]) || observed;
}
function $5599ea74f46bbff6$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$5599ea74f46bbff6$var$magic("nextTick", ()=>$5599ea74f46bbff6$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$5599ea74f46bbff6$var$magic("dispatch", (el)=>$5599ea74f46bbff6$var$dispatch.bind($5599ea74f46bbff6$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$5599ea74f46bbff6$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $5599ea74f46bbff6$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$5599ea74f46bbff6$var$magic("store", $5599ea74f46bbff6$var$getStores);
// packages/alpinejs/src/magics/$data.js
$5599ea74f46bbff6$var$magic("data", (el)=>$5599ea74f46bbff6$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$5599ea74f46bbff6$var$magic("root", (el)=>$5599ea74f46bbff6$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$5599ea74f46bbff6$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $5599ea74f46bbff6$var$mergeProxies($5599ea74f46bbff6$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $5599ea74f46bbff6$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $5599ea74f46bbff6$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $5599ea74f46bbff6$var$globalIdMemo = {};
function $5599ea74f46bbff6$var$findAndIncrementId(name) {
    if (!$5599ea74f46bbff6$var$globalIdMemo[name]) $5599ea74f46bbff6$var$globalIdMemo[name] = 0;
    return ++$5599ea74f46bbff6$var$globalIdMemo[name];
}
function $5599ea74f46bbff6$var$closestIdRoot(el, name) {
    return $5599ea74f46bbff6$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $5599ea74f46bbff6$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $5599ea74f46bbff6$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$5599ea74f46bbff6$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $5599ea74f46bbff6$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $5599ea74f46bbff6$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $5599ea74f46bbff6$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$5599ea74f46bbff6$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $5599ea74f46bbff6$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$5599ea74f46bbff6$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$5599ea74f46bbff6$var$warnMissingPluginMagic("Focus", "focus", "focus");
$5599ea74f46bbff6$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $5599ea74f46bbff6$var$warnMissingPluginMagic(name, magicName, slug) {
    $5599ea74f46bbff6$var$magic(magicName, (el)=>$5599ea74f46bbff6$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$5599ea74f46bbff6$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.setWithModifiers;
        let releaseEntanglement = $5599ea74f46bbff6$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$5599ea74f46bbff6$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $5599ea74f46bbff6$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $5599ea74f46bbff6$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $5599ea74f46bbff6$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $5599ea74f46bbff6$var$mutateDom(()=>{
        $5599ea74f46bbff6$var$skipDuringClone(()=>{
            placeInDom(clone2, target, modifiers);
            $5599ea74f46bbff6$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $5599ea74f46bbff6$var$getTarget(expression);
        $5599ea74f46bbff6$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$5599ea74f46bbff6$var$mutateDom(()=>{
            clone2.remove();
            $5599ea74f46bbff6$var$destroyTree(clone2);
        }));
});
var $5599ea74f46bbff6$var$teleportContainerDuringClone = document.createElement("div");
function $5599ea74f46bbff6$var$getTarget(expression) {
    let target = $5599ea74f46bbff6$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $5599ea74f46bbff6$var$teleportContainerDuringClone;
    })();
    if (!target) $5599ea74f46bbff6$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $5599ea74f46bbff6$var$handler = ()=>{};
$5599ea74f46bbff6$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$5599ea74f46bbff6$var$directive("ignore", $5599ea74f46bbff6$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$5599ea74f46bbff6$var$directive("effect", $5599ea74f46bbff6$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($5599ea74f46bbff6$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $5599ea74f46bbff6$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $5599ea74f46bbff6$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $5599ea74f46bbff6$var$camelCase2(event);
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("passive")) options.passive = modifiers[modifiers.indexOf("passive") + 1] !== "false";
    handler4 = $5599ea74f46bbff6$var$addDebounceOrThrottle(modifiers, handler4);
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($5599ea74f46bbff6$var$isKeyEvent(event) || $5599ea74f46bbff6$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($5599ea74f46bbff6$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $5599ea74f46bbff6$var$addDebounceOrThrottle(modifiers, handler4) {
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $5599ea74f46bbff6$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $5599ea74f46bbff6$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $5599ea74f46bbff6$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $5599ea74f46bbff6$var$throttle(handler4, wait);
    }
    return handler4;
}
function $5599ea74f46bbff6$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $5599ea74f46bbff6$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $5599ea74f46bbff6$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $5599ea74f46bbff6$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $5599ea74f46bbff6$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $5599ea74f46bbff6$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $5599ea74f46bbff6$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $5599ea74f46bbff6$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $5599ea74f46bbff6$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $5599ea74f46bbff6$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($5599ea74f46bbff6$var$isClickEvent(e.type)) return false;
            if ($5599ea74f46bbff6$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $5599ea74f46bbff6$var$keyToModifiers(key) {
    if (!key) return [];
    key = $5599ea74f46bbff6$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$5599ea74f46bbff6$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = $5599ea74f46bbff6$var$findClosest(el, (element)=>element !== el);
    let evaluateGet = $5599ea74f46bbff6$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $5599ea74f46bbff6$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $5599ea74f46bbff6$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $5599ea74f46bbff6$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($5599ea74f46bbff6$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $5599ea74f46bbff6$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($5599ea74f46bbff6$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($5599ea74f46bbff6$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($5599ea74f46bbff6$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($5599ea74f46bbff6$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let form = el.form;
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!form._x_pendingModelUpdates) form._x_pendingModelUpdates = [];
                form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>{
                    if (form._x_pendingModelUpdates) form._x_pendingModelUpdates.splice(form._x_pendingModelUpdates.indexOf(syncCallback), 1);
                });
            }
        }
        if (hasEnterModifier) listeners.push($5599ea74f46bbff6$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $5599ea74f46bbff6$var$on(el, event, modifiers, (e)=>{
            setValue($5599ea74f46bbff6$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $5599ea74f46bbff6$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($5599ea74f46bbff6$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $5599ea74f46bbff6$var$on(el.form, "reset", [], (e)=>{
            $5599ea74f46bbff6$var$nextTick(()=>el._x_model && el._x_model.set($5599ea74f46bbff6$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        },
        setWithModifiers: $5599ea74f46bbff6$var$addDebounceOrThrottle(modifiers, setValue)
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        $5599ea74f46bbff6$var$mutateDom(()=>{
            if ($5599ea74f46bbff6$var$isCheckbox(el)) {
                if (Array.isArray(value)) el.checked = value.some((val)=>val == el.value);
                else el.checked = !!value;
            } else if ($5599ea74f46bbff6$var$isRadio(el)) {
                if (typeof value === "boolean") el.checked = $5599ea74f46bbff6$var$safeParseBoolean(el.value) === value;
                else el.checked = el.value == value;
            } else $5599ea74f46bbff6$var$bind(el, "value", value);
        });
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $5599ea74f46bbff6$var$getInputValue(el, modifiers, event, currentValue) {
    return $5599ea74f46bbff6$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($5599ea74f46bbff6$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $5599ea74f46bbff6$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $5599ea74f46bbff6$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$5599ea74f46bbff6$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $5599ea74f46bbff6$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $5599ea74f46bbff6$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($5599ea74f46bbff6$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $5599ea74f46bbff6$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $5599ea74f46bbff6$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $5599ea74f46bbff6$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $5599ea74f46bbff6$var$isNumeric2(number) ? number : rawValue;
}
function $5599ea74f46bbff6$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $5599ea74f46bbff6$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $5599ea74f46bbff6$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$5599ea74f46bbff6$var$directive("cloak", (el)=>queueMicrotask(()=>$5599ea74f46bbff6$var$mutateDom(()=>el.removeAttribute($5599ea74f46bbff6$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$5599ea74f46bbff6$var$addInitSelector(()=>`[${$5599ea74f46bbff6$var$prefix("init")}]`);
$5599ea74f46bbff6$var$directive("init", $5599ea74f46bbff6$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$5599ea74f46bbff6$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $5599ea74f46bbff6$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$5599ea74f46bbff6$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $5599ea74f46bbff6$var$mutateDom(()=>{
                el.innerHTML = value ?? "";
                el._x_ignoreSelf = true;
                $5599ea74f46bbff6$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$5599ea74f46bbff6$var$mapAttributes($5599ea74f46bbff6$var$startingWith(":", $5599ea74f46bbff6$var$into($5599ea74f46bbff6$var$prefix("bind:"))));
var $5599ea74f46bbff6$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $5599ea74f46bbff6$var$injectBindingProviders(bindingProviders);
        let getBindings = $5599ea74f46bbff6$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $5599ea74f46bbff6$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $5599ea74f46bbff6$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $5599ea74f46bbff6$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $5599ea74f46bbff6$var$mutateDom(()=>$5599ea74f46bbff6$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$5599ea74f46bbff6$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$5599ea74f46bbff6$var$directive("bind", $5599ea74f46bbff6$var$handler2);
function $5599ea74f46bbff6$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$5599ea74f46bbff6$var$addRootSelector(()=>`[${$5599ea74f46bbff6$var$prefix("data")}]`);
$5599ea74f46bbff6$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($5599ea74f46bbff6$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $5599ea74f46bbff6$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $5599ea74f46bbff6$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $5599ea74f46bbff6$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $5599ea74f46bbff6$var$injectMagics(data2, el);
    let reactiveData = $5599ea74f46bbff6$var$reactive(data2);
    $5599ea74f46bbff6$var$initInterceptors(reactiveData);
    let undo = $5599ea74f46bbff6$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $5599ea74f46bbff6$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $5599ea74f46bbff6$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$5599ea74f46bbff6$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $5599ea74f46bbff6$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$5599ea74f46bbff6$var$isCloning) return false;
    if ($5599ea74f46bbff6$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$5599ea74f46bbff6$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $5599ea74f46bbff6$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $5599ea74f46bbff6$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $5599ea74f46bbff6$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $5599ea74f46bbff6$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$5599ea74f46bbff6$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $5599ea74f46bbff6$var$parseForExpression(expression);
    let evaluateItems = $5599ea74f46bbff6$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $5599ea74f46bbff6$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_lookup = /* @__PURE__ */ new Map();
    effect3(()=>$5599ea74f46bbff6$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        el._x_lookup.forEach((el2)=>$5599ea74f46bbff6$var$mutateDom(()=>{
                $5599ea74f46bbff6$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_lookup;
    });
});
function $5599ea74f46bbff6$var$refreshScope(scope2) {
    return (newScope)=>{
        Object.entries(newScope).forEach(([key, value])=>{
            scope2[key] = value;
        });
    };
}
function $5599ea74f46bbff6$var$loop(templateEl, iteratorNames, evaluateItems, evaluateKey) {
    evaluateItems((items)=>{
        if ($5599ea74f46bbff6$var$isNumeric3(items)) items = Array.from({
            length: items
        }, (_, i)=>i + 1);
        if (items === void 0 || items === null) items = [];
        if (items instanceof Set) items = Array.from(items);
        if (items instanceof Map) items = Array.from(items);
        let oldLookup = templateEl._x_lookup;
        let lookup = /* @__PURE__ */ new Map();
        templateEl._x_lookup = lookup;
        let hasStringKeys = $5599ea74f46bbff6$var$isObject2(items);
        let scopeEntries = Object.entries(items).map(([index, item])=>{
            if (!hasStringKeys) index = parseInt(index);
            let scope2 = $5599ea74f46bbff6$var$getIterationScopeVariables(iteratorNames, item, index, items);
            let key;
            evaluateKey((innerKey)=>{
                if (typeof innerKey === "object") $5599ea74f46bbff6$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
                if (oldLookup.has(innerKey)) {
                    lookup.set(innerKey, oldLookup.get(innerKey));
                    oldLookup.delete(innerKey);
                }
                key = innerKey;
            }, {
                scope: {
                    index: index,
                    ...scope2
                }
            });
            return [
                key,
                scope2
            ];
        });
        $5599ea74f46bbff6$var$mutateDom(()=>{
            oldLookup.forEach((el)=>{
                $5599ea74f46bbff6$var$destroyTree(el);
                el.remove();
            });
            let added = /* @__PURE__ */ new Set();
            let prev = templateEl;
            scopeEntries.forEach(([key, scope2])=>{
                if (lookup.has(key)) {
                    let el = lookup.get(key);
                    el._x_refreshXForScope(scope2);
                    if (prev.nextElementSibling !== el) {
                        if (prev.nextElementSibling) el.replaceWith(prev.nextElementSibling);
                        prev.after(el);
                    }
                    prev = el;
                    if (el._x_currentIfEl) {
                        if (el.nextElementSibling !== el._x_currentIfEl) prev.after(el._x_currentIfEl);
                        prev = el._x_currentIfEl;
                    }
                    return;
                }
                if (templateEl.content.children.length > 1) $5599ea74f46bbff6$var$warn("x-for templates require a single root element, additional elements will be ignored.", templateEl);
                let clone2 = document.importNode(templateEl.content, true).firstElementChild;
                let reactiveScope = $5599ea74f46bbff6$var$reactive(scope2);
                $5599ea74f46bbff6$var$addScopeToNode(clone2, reactiveScope, templateEl);
                clone2._x_refreshXForScope = $5599ea74f46bbff6$var$refreshScope(reactiveScope);
                lookup.set(key, clone2);
                added.add(clone2);
                prev.after(clone2);
                prev = clone2;
            });
            $5599ea74f46bbff6$var$skipDuringClone(()=>added.forEach((clone2)=>$5599ea74f46bbff6$var$initTree(clone2)))();
        });
    });
}
function $5599ea74f46bbff6$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $5599ea74f46bbff6$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $5599ea74f46bbff6$var$isNumeric3(subject) {
    return typeof subject !== "object" && !isNaN(subject);
}
function $5599ea74f46bbff6$var$isObject2(subject) {
    return typeof subject === "object" && !Array.isArray(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $5599ea74f46bbff6$var$handler3() {}
$5599ea74f46bbff6$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $5599ea74f46bbff6$var$closestRoot(el);
    if (!root) return;
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$5599ea74f46bbff6$var$directive("ref", $5599ea74f46bbff6$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$5599ea74f46bbff6$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $5599ea74f46bbff6$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $5599ea74f46bbff6$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $5599ea74f46bbff6$var$addScopeToNode(clone2, {}, el);
        $5599ea74f46bbff6$var$mutateDom(()=>{
            el.after(clone2);
            $5599ea74f46bbff6$var$skipDuringClone(()=>$5599ea74f46bbff6$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $5599ea74f46bbff6$var$mutateDom(()=>{
                $5599ea74f46bbff6$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$5599ea74f46bbff6$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$5599ea74f46bbff6$var$setIdRoot(el, name));
});
$5599ea74f46bbff6$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$5599ea74f46bbff6$var$mapAttributes($5599ea74f46bbff6$var$startingWith("@", $5599ea74f46bbff6$var$into($5599ea74f46bbff6$var$prefix("on:"))));
$5599ea74f46bbff6$var$directive("on", $5599ea74f46bbff6$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $5599ea74f46bbff6$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $5599ea74f46bbff6$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$5599ea74f46bbff6$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$5599ea74f46bbff6$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$5599ea74f46bbff6$var$warnMissingPluginDirective("Focus", "trap", "focus");
$5599ea74f46bbff6$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $5599ea74f46bbff6$var$warnMissingPluginDirective(name, directiveName, slug) {
    $5599ea74f46bbff6$var$directive(directiveName, (el)=>$5599ea74f46bbff6$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$5599ea74f46bbff6$var$alpine_default.setEvaluator($5599ea74f46bbff6$var$normalEvaluator);
$5599ea74f46bbff6$var$alpine_default.setRawEvaluator($5599ea74f46bbff6$var$normalRawEvaluator);
$5599ea74f46bbff6$var$alpine_default.setReactivityEngine({
    reactive: $5599ea74f46bbff6$var$reactive2,
    effect: $5599ea74f46bbff6$var$effect2,
    release: $5599ea74f46bbff6$var$stop,
    raw: $5599ea74f46bbff6$var$toRaw
});
var $5599ea74f46bbff6$export$b7ee041e4ad2afec = $5599ea74f46bbff6$var$alpine_default;
// packages/alpinejs/builds/module.js
var $5599ea74f46bbff6$export$2e2bcd8739ae039 = $5599ea74f46bbff6$export$b7ee041e4ad2afec;


// node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var $f5d5684b6dfa86ec$var$min = Math.min;
var $f5d5684b6dfa86ec$var$max = Math.max;
var $f5d5684b6dfa86ec$var$round = Math.round;
var $f5d5684b6dfa86ec$var$floor = Math.floor;
var $f5d5684b6dfa86ec$var$createCoords = (v)=>({
        x: v,
        y: v
    });
var $f5d5684b6dfa86ec$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
var $f5d5684b6dfa86ec$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $f5d5684b6dfa86ec$var$clamp(start, value, end) {
    return $f5d5684b6dfa86ec$var$max(start, $f5d5684b6dfa86ec$var$min(value, end));
}
function $f5d5684b6dfa86ec$var$evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $f5d5684b6dfa86ec$var$getSide(placement) {
    return placement.split("-")[0];
}
function $f5d5684b6dfa86ec$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $f5d5684b6dfa86ec$var$getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function $f5d5684b6dfa86ec$var$getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function $f5d5684b6dfa86ec$var$getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes($f5d5684b6dfa86ec$var$getSide(placement)) ? "y" : "x";
}
function $f5d5684b6dfa86ec$var$getAlignmentAxis(placement) {
    return $f5d5684b6dfa86ec$var$getOppositeAxis($f5d5684b6dfa86ec$var$getSideAxis(placement));
}
function $f5d5684b6dfa86ec$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $f5d5684b6dfa86ec$var$getAlignment(placement);
    const alignmentAxis = $f5d5684b6dfa86ec$var$getAlignmentAxis(placement);
    const length = $f5d5684b6dfa86ec$var$getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f5d5684b6dfa86ec$var$getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f5d5684b6dfa86ec$var$getOppositePlacement(mainAlignmentSide)
    ];
}
function $f5d5684b6dfa86ec$var$getExpandedPlacements(placement) {
    const oppositePlacement = $f5d5684b6dfa86ec$var$getOppositePlacement(placement);
    return [
        $f5d5684b6dfa86ec$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $f5d5684b6dfa86ec$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $f5d5684b6dfa86ec$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$f5d5684b6dfa86ec$var$oppositeAlignmentMap[alignment]);
}
function $f5d5684b6dfa86ec$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $f5d5684b6dfa86ec$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $f5d5684b6dfa86ec$var$getAlignment(placement);
    let list = $f5d5684b6dfa86ec$var$getSideList($f5d5684b6dfa86ec$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($f5d5684b6dfa86ec$var$getOppositeAlignmentPlacement));
    }
    return list;
}
function $f5d5684b6dfa86ec$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$f5d5684b6dfa86ec$var$oppositeSideMap[side]);
}
function $f5d5684b6dfa86ec$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $f5d5684b6dfa86ec$var$getPaddingObject(padding) {
    return typeof padding !== "number" ? $f5d5684b6dfa86ec$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f5d5684b6dfa86ec$var$rectToClientRect(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
// node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function $f5d5684b6dfa86ec$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = $f5d5684b6dfa86ec$var$getSideAxis(placement);
    const alignmentAxis = $f5d5684b6dfa86ec$var$getAlignmentAxis(placement);
    const alignLength = $f5d5684b6dfa86ec$var$getAxisLength(alignmentAxis);
    const side = $f5d5684b6dfa86ec$var$getSide(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($f5d5684b6dfa86ec$var$getAlignment(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
var $f5d5684b6dfa86ec$var$computePosition = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform2 } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
    let rects = await platform2.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $f5d5684b6dfa86ec$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform2,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform2.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $f5d5684b6dfa86ec$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
async function $f5d5684b6dfa86ec$var$detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform2, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = $f5d5684b6dfa86ec$var$evaluate(options, state);
    const paddingObject = $f5d5684b6dfa86ec$var$getPaddingObject(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $f5d5684b6dfa86ec$var$rectToClientRect(await platform2.getClippingRect({
        element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
    const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = $f5d5684b6dfa86ec$var$rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
var $f5d5684b6dfa86ec$var$flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform2, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = $f5d5684b6dfa86ec$var$evaluate(options, state);
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = $f5d5684b6dfa86ec$var$getSide(placement);
            const isBasePlacement = $f5d5684b6dfa86ec$var$getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $f5d5684b6dfa86ec$var$getOppositePlacement(initialPlacement)
            ] : $f5d5684b6dfa86ec$var$getExpandedPlacements(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...$f5d5684b6dfa86ec$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements2 = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $f5d5684b6dfa86ec$var$detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides2 = $f5d5684b6dfa86ec$var$getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            if (!overflows.every((side2)=>side2 <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements2[nextIndex];
                if (nextPlacement) return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement2 = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow2)=>overflow2 > 0).reduce((acc, overflow2)=>acc + overflow2, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement2) resetPlacement = placement2;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
async function $f5d5684b6dfa86ec$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform2, elements: elements } = state;
    const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
    const side = $f5d5684b6dfa86ec$var$getSide(placement);
    const alignment = $f5d5684b6dfa86ec$var$getAlignment(placement);
    const isVertical = $f5d5684b6dfa86ec$var$getSideAxis(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = $f5d5684b6dfa86ec$var$evaluate(options, state);
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
var $f5d5684b6dfa86ec$var$offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $f5d5684b6dfa86ec$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
var $f5d5684b6dfa86ec$var$shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x2, y: y2 } = _ref;
                    return {
                        x: x2,
                        y: y2
                    };
                }
            }, ...detectOverflowOptions } = $f5d5684b6dfa86ec$var$evaluate(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $f5d5684b6dfa86ec$var$detectOverflow(state, detectOverflowOptions);
            const crossAxis = $f5d5684b6dfa86ec$var$getSideAxis($f5d5684b6dfa86ec$var$getSide(placement));
            const mainAxis = $f5d5684b6dfa86ec$var$getOppositeAxis(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min2 = mainAxisCoord + overflow[minSide];
                const max2 = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $f5d5684b6dfa86ec$var$clamp(min2, mainAxisCoord, max2);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min2 = crossAxisCoord + overflow[minSide];
                const max2 = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $f5d5684b6dfa86ec$var$clamp(min2, crossAxisCoord, max2);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
// node_modules/@floating-ui/utils/dom/dist/floating-ui.utils.dom.mjs
function $f5d5684b6dfa86ec$var$getNodeName(node) {
    if ($f5d5684b6dfa86ec$var$isNode(node)) return (node.nodeName || "").toLowerCase();
    return "#document";
}
function $f5d5684b6dfa86ec$var$getWindow(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $f5d5684b6dfa86ec$var$getDocumentElement(node) {
    var _ref;
    return (_ref = ($f5d5684b6dfa86ec$var$isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $f5d5684b6dfa86ec$var$isNode(value) {
    return value instanceof Node || value instanceof $f5d5684b6dfa86ec$var$getWindow(value).Node;
}
function $f5d5684b6dfa86ec$var$isElement(value) {
    return value instanceof Element || value instanceof $f5d5684b6dfa86ec$var$getWindow(value).Element;
}
function $f5d5684b6dfa86ec$var$isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof $f5d5684b6dfa86ec$var$getWindow(value).HTMLElement;
}
function $f5d5684b6dfa86ec$var$isShadowRoot(value) {
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $f5d5684b6dfa86ec$var$getWindow(value).ShadowRoot;
}
function $f5d5684b6dfa86ec$var$isOverflowElement(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $f5d5684b6dfa86ec$var$getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $f5d5684b6dfa86ec$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($f5d5684b6dfa86ec$var$getNodeName(element));
}
function $f5d5684b6dfa86ec$var$isContainingBlock(element) {
    const webkit = $f5d5684b6dfa86ec$var$isWebKit();
    const css = $f5d5684b6dfa86ec$var$getComputedStyle(element);
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $f5d5684b6dfa86ec$var$getContainingBlock(element) {
    let currentNode = $f5d5684b6dfa86ec$var$getParentNode(element);
    while($f5d5684b6dfa86ec$var$isHTMLElement(currentNode) && !$f5d5684b6dfa86ec$var$isLastTraversableNode(currentNode)){
        if ($f5d5684b6dfa86ec$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $f5d5684b6dfa86ec$var$getParentNode(currentNode);
    }
    return null;
}
function $f5d5684b6dfa86ec$var$isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $f5d5684b6dfa86ec$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($f5d5684b6dfa86ec$var$getNodeName(node));
}
function $f5d5684b6dfa86ec$var$getComputedStyle(element) {
    return $f5d5684b6dfa86ec$var$getWindow(element).getComputedStyle(element);
}
function $f5d5684b6dfa86ec$var$getNodeScroll(element) {
    if ($f5d5684b6dfa86ec$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $f5d5684b6dfa86ec$var$getParentNode(node) {
    if ($f5d5684b6dfa86ec$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $f5d5684b6dfa86ec$var$isShadowRoot(node) && node.host || // Fallback.
    $f5d5684b6dfa86ec$var$getDocumentElement(node);
    return $f5d5684b6dfa86ec$var$isShadowRoot(result) ? result.host : result;
}
function $f5d5684b6dfa86ec$var$getNearestOverflowAncestor(node) {
    const parentNode = $f5d5684b6dfa86ec$var$getParentNode(node);
    if ($f5d5684b6dfa86ec$var$isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($f5d5684b6dfa86ec$var$isHTMLElement(parentNode) && $f5d5684b6dfa86ec$var$isOverflowElement(parentNode)) return parentNode;
    return $f5d5684b6dfa86ec$var$getNearestOverflowAncestor(parentNode);
}
function $f5d5684b6dfa86ec$var$getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $f5d5684b6dfa86ec$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $f5d5684b6dfa86ec$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $f5d5684b6dfa86ec$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $f5d5684b6dfa86ec$var$getOverflowAncestors(win.frameElement) : []);
    return list.concat(scrollableAncestor, $f5d5684b6dfa86ec$var$getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
// node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function $f5d5684b6dfa86ec$var$getCssDimensions(element) {
    const css = $f5d5684b6dfa86ec$var$getComputedStyle(element);
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = $f5d5684b6dfa86ec$var$isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = $f5d5684b6dfa86ec$var$round(width) !== offsetWidth || $f5d5684b6dfa86ec$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $f5d5684b6dfa86ec$var$unwrapElement(element) {
    return !$f5d5684b6dfa86ec$var$isElement(element) ? element.contextElement : element;
}
function $f5d5684b6dfa86ec$var$getScale(element) {
    const domElement = $f5d5684b6dfa86ec$var$unwrapElement(element);
    if (!$f5d5684b6dfa86ec$var$isHTMLElement(domElement)) return $f5d5684b6dfa86ec$var$createCoords(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $f5d5684b6dfa86ec$var$getCssDimensions(domElement);
    let x = ($ ? $f5d5684b6dfa86ec$var$round(rect.width) : rect.width) / width;
    let y = ($ ? $f5d5684b6dfa86ec$var$round(rect.height) : rect.height) / height;
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var $f5d5684b6dfa86ec$var$noOffsets = /* @__PURE__ */ $f5d5684b6dfa86ec$var$createCoords(0);
function $f5d5684b6dfa86ec$var$getVisualOffsets(element) {
    const win = $f5d5684b6dfa86ec$var$getWindow(element);
    if (!$f5d5684b6dfa86ec$var$isWebKit() || !win.visualViewport) return $f5d5684b6dfa86ec$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $f5d5684b6dfa86ec$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== $f5d5684b6dfa86ec$var$getWindow(element)) return false;
    return isFixed;
}
function $f5d5684b6dfa86ec$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $f5d5684b6dfa86ec$var$unwrapElement(element);
    let scale = $f5d5684b6dfa86ec$var$createCoords(1);
    if (includeScale) {
        if (offsetParent) {
            if ($f5d5684b6dfa86ec$var$isElement(offsetParent)) scale = $f5d5684b6dfa86ec$var$getScale(offsetParent);
        } else scale = $f5d5684b6dfa86ec$var$getScale(element);
    }
    const visualOffsets = $f5d5684b6dfa86ec$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $f5d5684b6dfa86ec$var$getVisualOffsets(domElement) : $f5d5684b6dfa86ec$var$createCoords(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $f5d5684b6dfa86ec$var$getWindow(domElement);
        const offsetWin = offsetParent && $f5d5684b6dfa86ec$var$isElement(offsetParent) ? $f5d5684b6dfa86ec$var$getWindow(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $f5d5684b6dfa86ec$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = $f5d5684b6dfa86ec$var$getComputedStyle(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = $f5d5684b6dfa86ec$var$getWindow(currentIFrame).frameElement;
        }
    }
    return $f5d5684b6dfa86ec$var$rectToClientRect({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $f5d5684b6dfa86ec$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = $f5d5684b6dfa86ec$var$isHTMLElement(offsetParent);
    const documentElement = $f5d5684b6dfa86ec$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = $f5d5684b6dfa86ec$var$createCoords(1);
    const offsets = $f5d5684b6dfa86ec$var$createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($f5d5684b6dfa86ec$var$getNodeName(offsetParent) !== "body" || $f5d5684b6dfa86ec$var$isOverflowElement(documentElement)) scroll = $f5d5684b6dfa86ec$var$getNodeScroll(offsetParent);
        if ($f5d5684b6dfa86ec$var$isHTMLElement(offsetParent)) {
            const offsetRect = $f5d5684b6dfa86ec$var$getBoundingClientRect(offsetParent);
            scale = $f5d5684b6dfa86ec$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $f5d5684b6dfa86ec$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $f5d5684b6dfa86ec$var$getWindowScrollBarX(element) {
    return $f5d5684b6dfa86ec$var$getBoundingClientRect($f5d5684b6dfa86ec$var$getDocumentElement(element)).left + $f5d5684b6dfa86ec$var$getNodeScroll(element).scrollLeft;
}
function $f5d5684b6dfa86ec$var$getDocumentRect(element) {
    const html = $f5d5684b6dfa86ec$var$getDocumentElement(element);
    const scroll = $f5d5684b6dfa86ec$var$getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = $f5d5684b6dfa86ec$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = $f5d5684b6dfa86ec$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $f5d5684b6dfa86ec$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($f5d5684b6dfa86ec$var$getComputedStyle(body).direction === "rtl") x += $f5d5684b6dfa86ec$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $f5d5684b6dfa86ec$var$getViewportRect(element, strategy) {
    const win = $f5d5684b6dfa86ec$var$getWindow(element);
    const html = $f5d5684b6dfa86ec$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = $f5d5684b6dfa86ec$var$isWebKit();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $f5d5684b6dfa86ec$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $f5d5684b6dfa86ec$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $f5d5684b6dfa86ec$var$isHTMLElement(element) ? $f5d5684b6dfa86ec$var$getScale(element) : $f5d5684b6dfa86ec$var$createCoords(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $f5d5684b6dfa86ec$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $f5d5684b6dfa86ec$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $f5d5684b6dfa86ec$var$getDocumentRect($f5d5684b6dfa86ec$var$getDocumentElement(element));
    else if ($f5d5684b6dfa86ec$var$isElement(clippingAncestor)) rect = $f5d5684b6dfa86ec$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $f5d5684b6dfa86ec$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return $f5d5684b6dfa86ec$var$rectToClientRect(rect);
}
function $f5d5684b6dfa86ec$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = $f5d5684b6dfa86ec$var$getParentNode(element);
    if (parentNode === stopNode || !$f5d5684b6dfa86ec$var$isElement(parentNode) || $f5d5684b6dfa86ec$var$isLastTraversableNode(parentNode)) return false;
    return $f5d5684b6dfa86ec$var$getComputedStyle(parentNode).position === "fixed" || $f5d5684b6dfa86ec$var$hasFixedPositionAncestor(parentNode, stopNode);
}
function $f5d5684b6dfa86ec$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $f5d5684b6dfa86ec$var$getOverflowAncestors(element, [], false).filter((el)=>$f5d5684b6dfa86ec$var$isElement(el) && $f5d5684b6dfa86ec$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $f5d5684b6dfa86ec$var$getComputedStyle(element).position === "fixed";
    let currentNode = elementIsFixed ? $f5d5684b6dfa86ec$var$getParentNode(element) : element;
    while($f5d5684b6dfa86ec$var$isElement(currentNode) && !$f5d5684b6dfa86ec$var$isLastTraversableNode(currentNode)){
        const computedStyle = $f5d5684b6dfa86ec$var$getComputedStyle(currentNode);
        const currentNodeIsContaining = $f5d5684b6dfa86ec$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $f5d5684b6dfa86ec$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $f5d5684b6dfa86ec$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
        else currentContainingBlockComputedStyle = computedStyle;
        currentNode = $f5d5684b6dfa86ec$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
function $f5d5684b6dfa86ec$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $f5d5684b6dfa86ec$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $f5d5684b6dfa86ec$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $f5d5684b6dfa86ec$var$max(rect.top, accRect.top);
        accRect.right = $f5d5684b6dfa86ec$var$min(rect.right, accRect.right);
        accRect.bottom = $f5d5684b6dfa86ec$var$min(rect.bottom, accRect.bottom);
        accRect.left = $f5d5684b6dfa86ec$var$max(rect.left, accRect.left);
        return accRect;
    }, $f5d5684b6dfa86ec$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $f5d5684b6dfa86ec$var$getDimensions(element) {
    return $f5d5684b6dfa86ec$var$getCssDimensions(element);
}
function $f5d5684b6dfa86ec$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $f5d5684b6dfa86ec$var$isHTMLElement(offsetParent);
    const documentElement = $f5d5684b6dfa86ec$var$getDocumentElement(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $f5d5684b6dfa86ec$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = $f5d5684b6dfa86ec$var$createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($f5d5684b6dfa86ec$var$getNodeName(offsetParent) !== "body" || $f5d5684b6dfa86ec$var$isOverflowElement(documentElement)) scroll = $f5d5684b6dfa86ec$var$getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $f5d5684b6dfa86ec$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $f5d5684b6dfa86ec$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $f5d5684b6dfa86ec$var$getTrueOffsetParent(element, polyfill) {
    if (!$f5d5684b6dfa86ec$var$isHTMLElement(element) || $f5d5684b6dfa86ec$var$getComputedStyle(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
function $f5d5684b6dfa86ec$var$getOffsetParent(element, polyfill) {
    const window2 = $f5d5684b6dfa86ec$var$getWindow(element);
    if (!$f5d5684b6dfa86ec$var$isHTMLElement(element)) return window2;
    let offsetParent = $f5d5684b6dfa86ec$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $f5d5684b6dfa86ec$var$isTableElement(offsetParent) && $f5d5684b6dfa86ec$var$getComputedStyle(offsetParent).position === "static")offsetParent = $f5d5684b6dfa86ec$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ($f5d5684b6dfa86ec$var$getNodeName(offsetParent) === "html" || $f5d5684b6dfa86ec$var$getNodeName(offsetParent) === "body" && $f5d5684b6dfa86ec$var$getComputedStyle(offsetParent).position === "static" && !$f5d5684b6dfa86ec$var$isContainingBlock(offsetParent))) return window2;
    return offsetParent || $f5d5684b6dfa86ec$var$getContainingBlock(element) || window2;
}
var $f5d5684b6dfa86ec$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $f5d5684b6dfa86ec$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $f5d5684b6dfa86ec$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $f5d5684b6dfa86ec$var$isRTL(element) {
    return $f5d5684b6dfa86ec$var$getComputedStyle(element).direction === "rtl";
}
var $f5d5684b6dfa86ec$var$platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $f5d5684b6dfa86ec$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f5d5684b6dfa86ec$var$getDocumentElement,
    getClippingRect: $f5d5684b6dfa86ec$var$getClippingRect,
    getOffsetParent: $f5d5684b6dfa86ec$var$getOffsetParent,
    getElementRects: $f5d5684b6dfa86ec$var$getElementRects,
    getClientRects: $f5d5684b6dfa86ec$var$getClientRects,
    getDimensions: $f5d5684b6dfa86ec$var$getDimensions,
    getScale: $f5d5684b6dfa86ec$var$getScale,
    isElement: $f5d5684b6dfa86ec$var$isElement,
    isRTL: $f5d5684b6dfa86ec$var$isRTL
};
function $f5d5684b6dfa86ec$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = $f5d5684b6dfa86ec$var$getDocumentElement(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = $f5d5684b6dfa86ec$var$floor(top);
        const insetRight = $f5d5684b6dfa86ec$var$floor(root.clientWidth - (left + width));
        const insetBottom = $f5d5684b6dfa86ec$var$floor(root.clientHeight - (top + height));
        const insetLeft = $f5d5684b6dfa86ec$var$floor(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: $f5d5684b6dfa86ec$var$max(0, $f5d5684b6dfa86ec$var$min(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
function $f5d5684b6dfa86ec$var$autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $f5d5684b6dfa86ec$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? $f5d5684b6dfa86ec$var$getOverflowAncestors(referenceEl) : [],
        ...$f5d5684b6dfa86ec$var$getOverflowAncestors(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $f5d5684b6dfa86ec$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $f5d5684b6dfa86ec$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $f5d5684b6dfa86ec$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
var $f5d5684b6dfa86ec$var$computePosition2 = (reference, floating, options)=>{
    const cache = /* @__PURE__ */ new Map();
    const mergedOptions = {
        platform: $f5d5684b6dfa86ec$var$platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return $f5d5684b6dfa86ec$var$computePosition(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};
// packages/anchor/src/index.js
function $f5d5684b6dfa86ec$export$2e2992790a6f69a8(Alpine) {
    Alpine.magic("anchor", (el)=>{
        if (!el._x_anchor) throw "Alpine: No x-anchor directive found on element using $anchor...";
        return el._x_anchor;
    });
    Alpine.interceptClone((from, to)=>{
        if (from && from._x_anchor && !to._x_anchor) to._x_anchor = from._x_anchor;
    });
    Alpine.directive("anchor", Alpine.skipDuringClone((el, { expression: expression, modifiers: modifiers, value: value }, { evaluate: evaluate2, effect: effect, cleanup: cleanup })=>{
        let { placement: placement, offsetValue: offsetValue, unstyled: unstyled, strategy: strategy, allowFlip: allowFlip } = $f5d5684b6dfa86ec$var$getOptions(modifiers);
        el._x_anchor = Alpine.reactive({
            x: 0,
            y: 0
        });
        let previousReference = null;
        let release = null;
        effect(()=>{
            let reference = evaluate2(expression);
            if (!reference) return;
            if (previousReference !== reference) {
                if (release) release();
                previousReference = reference;
                let compute = ()=>{
                    let previousValue;
                    $f5d5684b6dfa86ec$var$computePosition2(reference, el, {
                        placement: placement,
                        strategy: strategy,
                        middleware: [
                            allowFlip && $f5d5684b6dfa86ec$var$flip(),
                            $f5d5684b6dfa86ec$var$shift({
                                padding: 5
                            }),
                            $f5d5684b6dfa86ec$var$offset(offsetValue)
                        ]
                    }).then(({ x: x, y: y })=>{
                        unstyled || $f5d5684b6dfa86ec$var$setStyles(el, x, y, strategy);
                        if (JSON.stringify({
                            x: x,
                            y: y
                        }) !== previousValue) {
                            el._x_anchor.x = x;
                            el._x_anchor.y = y;
                        }
                        previousValue = JSON.stringify({
                            x: x,
                            y: y
                        });
                    });
                };
                release = $f5d5684b6dfa86ec$var$autoUpdate(reference, el, ()=>compute());
            }
        });
        cleanup(()=>{
            if (release) release();
        });
    }, // When cloning (or "morphing"), we will graft the style and position data from the live tree...
    (el, { expression: expression, modifiers: modifiers, value: value }, { cleanup: cleanup, evaluate: evaluate2 })=>{
        let { placement: placement, offsetValue: offsetValue, unstyled: unstyled, strategy: strategy } = $f5d5684b6dfa86ec$var$getOptions(modifiers);
        if (el._x_anchor) unstyled || $f5d5684b6dfa86ec$var$setStyles(el, el._x_anchor.x, el._x_anchor.y, strategy);
    }));
}
function $f5d5684b6dfa86ec$var$setStyles(el, x, y, strategy = "absolute") {
    Object.assign(el.style, {
        left: x + "px",
        top: y + "px",
        position: strategy
    });
}
function $f5d5684b6dfa86ec$var$getOptions(modifiers) {
    let positions = [
        "top",
        "top-start",
        "top-end",
        "right",
        "right-start",
        "right-end",
        "bottom",
        "bottom-start",
        "bottom-end",
        "left",
        "left-start",
        "left-end"
    ];
    let placement = positions.find((i)=>modifiers.includes(i));
    let offsetValue = 0;
    if (modifiers.includes("offset")) {
        let idx = modifiers.findIndex((i)=>i === "offset");
        offsetValue = modifiers[idx + 1] !== void 0 ? Number(modifiers[idx + 1]) : offsetValue;
    }
    let unstyled = modifiers.includes("no-style");
    let allowFlip = !modifiers.includes("noflip");
    let strategy = modifiers.includes("fixed") ? "fixed" : "absolute";
    return {
        placement: placement,
        offsetValue: offsetValue,
        unstyled: unstyled,
        strategy: strategy,
        allowFlip: allowFlip
    };
}
// packages/anchor/builds/module.js
var $f5d5684b6dfa86ec$export$2e2bcd8739ae039 = $f5d5684b6dfa86ec$export$2e2992790a6f69a8;


function $18b7bec3e95b7767$export$ecaf77c28e5b5ef9(url) {
    // save URL to cookie for 3 hours to be later used in keep shopping link in cart
    const now = new Date();
    now.setTime(now.getTime() + 10800000);
    document.cookie = "collection_url=" + url + "; expires=" + now.toUTCString() + "; path=/";
}
function $18b7bec3e95b7767$export$d63e23ced30638e5(payload) {
    if (!window.dataLayer) return;
    window.dataLayer.push(payload);
}




(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("bundleUpsell", (variantIds)=>({
        loading: false,
        async addToCart () {
            if (this.loading) return;
            this.loading = true;
            const items = variantIds.split(",").map((id)=>({
                    id: id,
                    quantity: 1
                })).filter((item)=>item.id !== "");
            try {
                await fetch(`${window.routes.cart_add_url}.js`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: items
                    })
                });
                // cross-sell banner Add to Cart analytics
                (0, $18b7bec3e95b7767$export$d63e23ced30638e5)({
                    event: "crosssell_add_to_cart",
                    journey: this.$root?.dataset?.journey
                });
                // Adding the paired past paper flips the whole cart state (cross-sell banner
                // hides, upsell banner + recommendations appear), so reload to re-evaluate it
                // all. A partial swap can't remove the now-gone banner, leaving it re-clickable.
                window.location.reload();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error({
                    error: error
                });
                this.loading = false;
            }
        }
    }));




(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("upsellProducts", ()=>({
        async addToCart () {
            this.$el.disabled = "true";
            const counter = this.$el.previousElementSibling;
            const quantity = counter ? counter.dataset.count : 1;
            const variantId = this.$el.dataset.productId;
            const { position: position } = this.$el.dataset;
            const journey = this.$root?.dataset?.journey;
            const items = [
                {
                    id: variantId,
                    quantity: quantity
                }
            ];
            // recommendation analytics
            (0, $18b7bec3e95b7767$export$d63e23ced30638e5)({
                event: "recommendation_click",
                variantId: variantId,
                position: position,
                journey: journey
            });
            try {
                await fetch(`${window.routes.cart_add_url}.js`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: items
                    })
                });
                (0, $18b7bec3e95b7767$export$d63e23ced30638e5)({
                    event: "recommendation_add_to_cart",
                    variantId: variantId,
                    position: position,
                    journey: journey
                });
                // Adding a past paper can flip the cart banners (cross-sell <-> upsell) and
                // changes totals/discount tiers, which a partial DOM swap can't represent.
                // Reload to re-render the whole cart consistently.
                window.location.reload();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error({
                    error: error
                });
                this.$el.disabled = "false";
            }
        }
    }));



const $20df8850909213d7$var$HOVER_TOLERANCE_MS = 200;
(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("header", ()=>{
    const menuTimeouts = {};
    return {
        menu: {},
        handleHover (event) {
            const parent = event.target.parentElement;
            const menuItem = parent.dataset.menuItem;
            if (menuItem) {
                this.menu = {};
                this.menu[menuItem] = true;
            }
        },
        handleMouseEnter (event) {
            const parent = event.target;
            const menuItem = parent.dataset.menuItem;
            if (menuTimeouts[menuItem]) clearTimeout(menuTimeouts[menuItem]);
        },
        handleMouseLeave (event) {
            const parent = event.target;
            const menuItem = parent.dataset.menuItem;
            menuTimeouts[menuItem] = setTimeout(()=>{
                if (menuItem) this.menu[menuItem] = false;
            }, $20df8850909213d7$var$HOVER_TOLERANCE_MS);
        },
        handleKeyDown (event) {
            const parent = event.target.parentElement;
            const menuItem = parent.dataset.menuItem;
            if (event.key === " ") {
                event.preventDefault();
                event.stopPropagation();
                if (this.menu[menuItem]) {
                    // Close the menu
                    this.menu = {};
                    this.menu[menuItem] = false;
                } else {
                    this.menu = {};
                    this.menu[menuItem] = true;
                }
            }
        },
        handleFocusOut (event) {
            if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) return;
            const menuitem = event.currentTarget.dataset.menuItem;
            if (menuitem) this.menu[menuitem] = false;
        },
        openHamburger (event) {
            event.preventDefault();
            event.stopPropagation();
            this.$dispatch("hamburger");
        }
    };
});
(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("hamburger", ()=>{
    let previousFocus = null;
    return {
        isOpen: false,
        focusHandler: null,
        clickOutsideHandler: null,
        menu: {},
        init () {
            this.focusHandler = this.handleFocusOutside.bind(this);
            this.clickOutsideHandler = this.handleClickOutside.bind(this);
        },
        handleFocusOutside (event) {
            if (!this.$refs.hamburger.contains(event.target)) // Return focus to the hamburger
            this.$refs.homeLink?.focus();
        },
        handleClickOutside (event) {
            if (!this.$refs.hamburger.contains(event.target)) this.closeMenu();
        },
        openMenu () {
            this.isOpen = true;
            document.body.classList.add("no-scroll");
            if (document.activeElement) previousFocus = document.activeElement;
            // Required to allow click focus event to complete first.
            setTimeout(()=>{
                this.$refs.homeLink?.focus();
            });
            window.addEventListener("focusin", this.focusHandler);
            window.addEventListener("click", this.clickOutsideHandler);
        },
        closeMenu () {
            this.isOpen = false;
            document.body.classList.remove("no-scroll");
            window.removeEventListener("focusin", this.focusHandler);
            window.removeEventListener("click", this.clickOutsideHandler);
            if (previousFocus) setTimeout(()=>{
                previousFocus.focus();
            });
        },
        toggleSubmenu (name) {
            if (this.menu[name]) delete this.menu[name];
            else this.menu[name] = true;
        }
    };
});



// The login service and Primda behind it go to sleep when idle (mostly in UAT). The first
// request after that can outlast the Shopify app proxy, which then answers with its own
// HTML error page instead of our JSON. A second attempt normally succeeds, so retry
// those cases quietly instead of showing a JSON parse error.
const $74388b205eb7d9e7$var$MAX_ATTEMPTS = 3;
const $74388b205eb7d9e7$var$RETRY_DELAY_MS = 1500;
const $74388b205eb7d9e7$var$REQUEST_TIMEOUT_MS = 30000;
const $74388b205eb7d9e7$var$UNREACHABLE_MESSAGE = "We could not reach the login service. Please wait a moment and try again.";
class $74388b205eb7d9e7$var$LoginServiceUnreachable extends Error {
}
const $74388b205eb7d9e7$var$wait = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
async function $74388b205eb7d9e7$var$postAuthenticate(body) {
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), $74388b205eb7d9e7$var$REQUEST_TIMEOUT_MS);
    try {
        const response = await fetch(`${window.location.origin}/apps/acidgreen/authenticate`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
            signal: controller.signal
        });
        try {
            return {
                response: response,
                json: await response.json()
            };
        } catch  {
            throw new $74388b205eb7d9e7$var$LoginServiceUnreachable();
        }
    } catch (e) {
        // Network failures and timeouts reject the fetch itself.
        throw e instanceof $74388b205eb7d9e7$var$LoginServiceUnreachable ? e : new $74388b205eb7d9e7$var$LoginServiceUnreachable();
    } finally{
        clearTimeout(timer);
    }
}
(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("SchoolLogin", ()=>({
        loading: false,
        errorCode: undefined,
        errorText: "",
        form: {
            code: "",
            password: ""
        },
        handleSubmit: async function(e) {
            e.preventDefault();
            this.loading = true;
            this.errorText = "";
            this.errorCode = undefined;
            const redirect = this.$refs.form.getAttribute("data-redirect");
            const body = {
                username: this.form.code,
                password: this.form.password,
                returnUrl: redirect
            };
            let result;
            for(let attempt = 1; attempt <= $74388b205eb7d9e7$var$MAX_ATTEMPTS && !result; attempt++)try {
                result = await $74388b205eb7d9e7$var$postAuthenticate(body);
            } catch  {
                if (attempt < $74388b205eb7d9e7$var$MAX_ATTEMPTS) await $74388b205eb7d9e7$var$wait($74388b205eb7d9e7$var$RETRY_DELAY_MS);
            }
            if (!result) {
                this.errorText = $74388b205eb7d9e7$var$UNREACHABLE_MESSAGE;
                this.loading = false;
                return;
            }
            const { response: response, json: json } = result;
            if (json.status === "success") {
                if (json.url) {
                    window.localStorage.setItem("force-school-region", "true");
                    location.href = json.url.replace("unsw-global.myshopify.com", "shop.icasassessments.com");
                    return;
                }
                this.errorText = json.message;
            } else if (response.status == 422 && json.code == "SHOPIFY_EMAIL_TAKEN") // The template will show a div with text that can be configured in Shopify
            this.errorCode = json.code;
            else this.errorText = json.message || $74388b205eb7d9e7$var$UNREACHABLE_MESSAGE;
            this.loading = false;
        }
    }));




(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("PpsSchool", ()=>({
        loading: false,
        hasErrors: false,
        hasAccess: true,
        form: {
            code: ""
        },
        handleSubmit: async function(e) {
            e.preventDefault();
            this.hasErrors = false;
            this.loading = true;
            this.hasAccess = true;
            try {
                if (window.theme.parentPaymentSystem !== "new") {
                    const response = await fetch(`/apps/acidgreen/parent_payment/${this.form.code}`);
                    const json = await response.json();
                    if (!response.ok || json && json.status === "fail") {
                        this.hasErrors = true;
                        this.loading = false;
                        return;
                    }
                    const url = `/collections/${json.handle}`;
                    (0, $18b7bec3e95b7767$export$ecaf77c28e5b5ef9)(url);
                    window.location.href = url;
                } else {
                    const parentPaymentCode = this.form.code.trim().toUpperCase();
                    if (parentPaymentCode.length > 8) {
                        this.hasErrors = true;
                        this.loading = false;
                        return;
                    }
                    const parentPaymentLink = `/pages/parent-payment/${parentPaymentCode}`;
                    // We fetch and check that the page exits before redirecting:
                    const result = await fetch(parentPaymentLink);
                    if (!result.ok) {
                        this.hasErrors = true;
                        this.loading = false;
                        return;
                    }
                    window.location.href = parentPaymentLink;
                }
            } catch (e) {
                this.hasErrors = true;
                this.loading = false;
            } finally{
                this.loading = false;
            }
        }
    }));





(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("selectSubjects", ()=>({
        loading: false,
        hasErrors: false,
        students: [],
        accessCodes: [],
        total: 0,
        totalPrice: 0,
        schoolInfo: {},
        init () {},
        async clearStudentCart () {
            const updates = {};
            const response = await fetch("/cart.json");
            const cart = await response.json();
            for (const cartItem of cart.items)if (cartItem.properties?._origin != undefined) updates[cartItem.key] = 0;
            if (Object.keys(updates).length) return fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: updates
                })
            });
        },
        async processStudentList () {
            this.students = [];
            this.schoolInfo = window.ppsSchoolDetails;
            const studentList = window.studentList;
            const studentListKeyValues = Object.entries(studentList);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            studentListKeyValues.forEach(([_key, studentListItem])=>{
                this.students.push(studentListItem);
                this.total += studentListItem.variants.length;
            });
        },
        getLevyConfig () {
            const collection = window.collection;
            return collection?.levy ?? {
                enabled: false,
                variantId: null
            };
        },
        async handleSubmit (e) {
            e.preventDefault();
            this.hasErrors = false;
            this.loading = true;
            try {
                await this.clearStudentCart();
                await this.processStudentList();
                // The School Program Support Fee is added once per student by the janison-ecommerce-app cart transform,
                // which looks for _levy_enabled on the student's tests.
                const levy = this.getLevyConfig();
                const levyEnabled = levy.enabled && Boolean(levy.variantId);
                const assessmentItems = [];
                const relatedVariantItems = [];
                this.students.forEach((s)=>{
                    const student = s;
                    student.variants.forEach((variant)=>{
                        const properties = {
                            student_firstname: student.studentFirstname,
                            student_lastname: student.studentLastname,
                            student_dob: student.studentDob,
                            student_year: student.studentYear,
                            school_name: this.schoolInfo.schoolName,
                            _school_code: this.schoolInfo.schoolCode,
                            _school_name: this.schoolInfo.schoolName,
                            _origin: "parent",
                            _address_line_1: this.schoolInfo.addressLine1,
                            _address_line_2: this.schoolInfo.addressLine2,
                            _suburb: this.schoolInfo.suburb,
                            _country_name: this.schoolInfo.countryName,
                            _state_name: this.schoolInfo.stateName,
                            _post_code: this.schoolInfo.postCode,
                            ...levyEnabled && {
                                _levy_enabled: "true"
                            }
                        };
                        if (!variant?.variantId) {
                            console.warn("Invalid variantId for student", student.studentFirstname, student.studentLastname);
                            return;
                        }
                        // Add the assessment item
                        assessmentItems.push({
                            id: variant.variantId,
                            quantity: 1,
                            properties: properties
                        });
                        if (variant.relatedVariantId) relatedVariantItems.push({
                            id: variant.relatedVariantId,
                            quantity: 1,
                            properties: {
                                _origin: "parent"
                            }
                        });
                    });
                });
                // Add assessment items first
                const assessmentResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: assessmentItems
                    })
                });
                if (!assessmentResponse.ok) {
                    this.hasErrors = true;
                    return;
                }
                // Add related variant items (bundles)
                if (relatedVariantItems.length > 0) await fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: relatedVariantItems
                    })
                });
                window.location.href = "/cart";
            } catch (e) {
                console.error(e);
                this.hasErrors = true;
            } finally{
                this.loading = false;
            }
        }
    }));



/**
 * Mode tie-breaker preference. When a single (subject, paperYear) pair has
 * multiple variants, only one is included in a pack — Online wins over
 * Interactive PDF wins over PDF.
 */ const $0ab6db91e7d48544$var$MODE_PRIORITY = {
    Online: 0,
    "Interactive PDF": 1,
    PDF: 2
};
function $0ab6db91e7d48544$var$modeRank(mode) {
    const rank = $0ab6db91e7d48544$var$MODE_PRIORITY[mode];
    return rank === undefined ? 99 : rank;
}
/**
 * Group papers by (subject, paperYear), keeping only the highest-priority mode
 * for each pair.
 */ function $0ab6db91e7d48544$var$pickByModeTieBreaker(papers) {
    const bySubjectAndYear = new Map();
    papers.forEach((paper)=>{
        const key = `${paper.subject}::${paper.paperYear}`;
        const existing = bySubjectAndYear.get(key);
        if (!existing || $0ab6db91e7d48544$var$modeRank(paper.mode) < $0ab6db91e7d48544$var$modeRank(existing.mode)) bySubjectAndYear.set(key, paper);
    });
    return Array.from(bySubjectAndYear.values());
}
/** Papers for one subject, mode-deduped, sorted by paperYear descending. */ function $0ab6db91e7d48544$var$subjectPapersSorted(papers, subject) {
    return $0ab6db91e7d48544$var$pickByModeTieBreaker(papers.filter((p)=>p.subject === subject)).sort((a, b)=>parseInt(b.paperYear, 10) - parseInt(a.paperYear, 10));
}
/**
 * Take the top N most-recent papers per selected subject. If a subject has
 * fewer than N papers, take what's available.
 */ function $0ab6db91e7d48544$var$topNPerSubject(papers, subjects, n) {
    const result = [];
    for (const subject of subjects)result.push(...$0ab6db91e7d48544$var$subjectPapersSorted(papers, subject).slice(0, n));
    return result;
}
/**
 * Top up a pack to `target` papers by pulling extras from the selected
 * subjects in priority order. Checks the selected year first, then walks
 * down through lower year levels. Used by Foundation and Essential to avoid
 * showing under-filled packs when a subject has fewer papers than expected.
 */ function $0ab6db91e7d48544$var$fillToTarget(primary, target, allPapers, subjects, selectedYear, yearLevelOrder) {
    if (primary.length >= target) return primary;
    const result = [
        ...primary
    ];
    const used = new Set(result.map((p)=>p.variantId));
    const selectedIdx = yearLevelOrder.indexOf(selectedYear);
    for (const subject of subjects){
        if (result.length >= target) break;
        for(let i = selectedIdx; i >= 0 && result.length < target; i -= 1){
            const code = yearLevelOrder[i];
            const candidates = allPapers.filter((p)=>p.subject === subject && p.difficulties.includes(code) && !used.has(p.variantId));
            const sorted = $0ab6db91e7d48544$var$pickByModeTieBreaker(candidates).sort((a, b)=>parseInt(b.paperYear, 10) - parseInt(a.paperYear, 10));
            for (const p of sorted){
                if (result.length >= target) break;
                result.push(p);
                used.add(p.variantId);
            }
        }
    }
    return result;
}
const $0ab6db91e7d48544$export$b8d8cdc1f45bd334 = ({ papers: papers, allPapers: allPapers, subjects: subjects, selectedYear: selectedYear, yearLevelOrder: yearLevelOrder })=>{
    if (subjects.length === 1) return $0ab6db91e7d48544$var$topNPerSubject(papers, subjects, 2);
    const primary = $0ab6db91e7d48544$var$topNPerSubject(papers, subjects, 1);
    if (subjects.length !== 2) return primary;
    return $0ab6db91e7d48544$var$fillToTarget(primary, 2, allPapers, subjects, selectedYear, yearLevelOrder);
};
const $0ab6db91e7d48544$export$7cc222b91d217650 = ({ papers: papers, allPapers: allPapers, subjects: subjects, selectedYear: selectedYear, yearLevelOrder: yearLevelOrder })=>{
    if (subjects.length === 1) return $0ab6db91e7d48544$var$topNPerSubject(papers, subjects, 4);
    const primary = $0ab6db91e7d48544$var$topNPerSubject(papers, subjects, 2);
    const target = subjects.length * 2;
    return $0ab6db91e7d48544$var$fillToTarget(primary, target, allPapers, subjects, selectedYear, yearLevelOrder);
};
const $0ab6db91e7d48544$export$8f511ad3691f9204 = ({ papers: papers, subjects: subjects })=>{
    const result = [];
    for (const subject of subjects)result.push(...$0ab6db91e7d48544$var$subjectPapersSorted(papers, subject));
    return result;
};
const $0ab6db91e7d48544$export$747444d7e22037e2 = [
    {
        id: "foundation",
        contentKey: "foundation_practice_pack",
        rule: $0ab6db91e7d48544$export$b8d8cdc1f45bd334
    },
    {
        id: "essential",
        contentKey: "essential_practice_pack",
        rule: $0ab6db91e7d48544$export$7cc222b91d217650
    },
    {
        id: "complete",
        contentKey: "complete_practice_pack",
        rule: $0ab6db91e7d48544$export$8f511ad3691f9204
    }
];
const $0ab6db91e7d48544$export$e4d6ea148b051bba = {
    foundation_practice_pack: {
        displayName: "Foundation practice",
        description: "An introduction to ICAS preparation that helps students start building confidence and familiarity with unique ICAS question styles and difficulty levels.",
        tagline: "Build familiarity",
        badgeText: "",
        popular: false
    },
    essential_practice_pack: {
        displayName: "Essential practice",
        description: "For students who benefit from broader exposure to ICAS question styles, helping them feel capable, prepared and ready for competition day.",
        tagline: "Prepare thoroughly",
        badgeText: "Most popular",
        popular: true
    },
    complete_practice_pack: {
        displayName: "Complete practice",
        description: "The most extensive preparation, helping students maximise familiarity with ICAS question styles and feel fully prepared to achieve their best.",
        tagline: "Maximum readiness",
        badgeText: "",
        popular: false
    }
};
function $0ab6db91e7d48544$export$9fd6ca145b0665f3(paperCount) {
    if (paperCount >= 11) return 40;
    if (paperCount >= 8) return 30;
    if (paperCount >= 5) return 25;
    if (paperCount >= 4) return 20;
    return 0;
}


const $46c3a45bcc5b74dc$var$SECOND_TOAST_DISMISS_MS = 8000;
const $46c3a45bcc5b74dc$var$TIER_TOAST_DISMISS_MS = 5000;
const $46c3a45bcc5b74dc$var$DEFAULT_SETTINGS = {
    yearLevels: [],
    subjectIcons: {},
    tooltips: {
        online: "",
        interactivePdf: "",
        pdf: "",
        autoMarking: "",
        answerSheets: ""
    },
    toast: {
        headingTemplate: "{type} added to cart",
        buyAnotherLabel: "Buy for another child",
        proceedLabel: "Proceed to cart"
    },
    tierToasts: {
        "3": "",
        "5": "",
        "8": ""
    },
    currency: {
        isoCode: "AUD",
        moneyFormat: "${{amount}}",
        moneyWithCurrencyFormat: "${{amount}} AUD"
    }
};
function $46c3a45bcc5b74dc$var$safeParseJson(text, fallback) {
    if (!text) return fallback;
    try {
        return JSON.parse(text);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("past-papers-builder: failed to parse JSON payload", e);
        return fallback;
    }
}
/**
 * Delimiter rules for every placeholder Shopify can put in a money format,
 * mirroring the switch in Shopify's own `currency.js`. Markets hand us the
 * presentment currency's format, so a store selling in AUD still has to render
 * `Rp {{amount_with_comma_separator}}` for the Indonesia market.
 */ const $46c3a45bcc5b74dc$var$MONEY_PLACEHOLDERS = {
    amount: {
        decimals: 2,
        thousands: ",",
        decimal: "."
    },
    amount_no_decimals: {
        decimals: 0,
        thousands: ",",
        decimal: "."
    },
    amount_with_comma_separator: {
        decimals: 2,
        thousands: ".",
        decimal: ","
    },
    amount_no_decimals_with_comma_separator: {
        decimals: 0,
        thousands: ".",
        decimal: ","
    },
    amount_with_apostrophe_separator: {
        decimals: 2,
        thousands: "'",
        decimal: "."
    },
    amount_with_space_separator: {
        decimals: 2,
        thousands: " ",
        decimal: ","
    },
    amount_no_decimals_with_space_separator: {
        decimals: 0,
        thousands: " ",
        decimal: "."
    },
    amount_with_period_and_space_separator: {
        decimals: 2,
        thousands: " ",
        decimal: "."
    }
};
/**
 * Substitute a cents amount into a Shopify money-format template. Individual
 * paper prices come pre-formatted from Liquid (`| money`) so this only runs
 * for client-computed pack totals.
 *
 * Unrecognised placeholders fall back to `amount` rather than being left in
 * place, so a format we don't know about degrades to a plausible price instead
 * of leaking `{{...}}` into the pack card.
 */ function $46c3a45bcc5b74dc$var$substituteAmount(format, cents) {
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, name)=>{
        const rule = $46c3a45bcc5b74dc$var$MONEY_PLACEHOLDERS[name] ?? $46c3a45bcc5b74dc$var$MONEY_PLACEHOLDERS.amount;
        const [whole, fraction] = (cents / 100).toFixed(rule.decimals).split(".");
        const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, rule.thousands);
        return fraction ? grouped + rule.decimal + fraction : grouped;
    });
}
(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("pastPapersBuilder", ()=>({
        // ─── State ────────────────────────────────────────────────────────────
        papers: [],
        /** Difficulty code of the selected year pill; null = no filter (all years). */ selectedYear: null,
        selectedSubjects: [],
        buttonStates: {},
        buttonErrors: {},
        /** Past-paper variants currently in the cart (refreshed on init + after every add). */ _cartPastPaperCount: 0,
        /** Highest tier-toast threshold already shown this session; suppresses re-fires. */ _lastFiredTier: 0,
        /** Year-level codes whose accordions are currently expanded. */ openAccordions: [],
        packContent: {},
        settings: $46c3a45bcc5b74dc$var$DEFAULT_SETTINGS,
        tierToast: {
            visible: false,
            message: ""
        },
        secondToast: {
            visible: false,
            heading: ""
        },
        _tierToastTimer: 0,
        _secondToastTimer: 0,
        _cartController: null,
        // ─── Init ─────────────────────────────────────────────────────────────
        init () {
            const root = this.$el;
            const papersScript = root.querySelector("script[data-papers]");
            const payload = $46c3a45bcc5b74dc$var$safeParseJson(papersScript?.textContent || null, {
                papers: []
            });
            this.papers = payload.papers;
            if (payload._truncated) // eslint-disable-next-line no-console
            console.warn("past-papers-builder: collection has more than 50 products; some papers were omitted from the payload.");
            const contentScript = root.querySelector("script[data-pack-content]");
            this.packContent = $46c3a45bcc5b74dc$var$safeParseJson(contentScript?.textContent || null, {});
            const settingsScript = root.querySelector("script[data-section-settings]");
            const parsed = $46c3a45bcc5b74dc$var$safeParseJson(settingsScript?.textContent || null, {});
            this.settings = {
                ...$46c3a45bcc5b74dc$var$DEFAULT_SETTINGS,
                ...parsed,
                tooltips: {
                    ...$46c3a45bcc5b74dc$var$DEFAULT_SETTINGS.tooltips,
                    ...parsed.tooltips || {}
                },
                toast: {
                    ...$46c3a45bcc5b74dc$var$DEFAULT_SETTINGS.toast,
                    ...parsed.toast || {}
                },
                tierToasts: {
                    ...$46c3a45bcc5b74dc$var$DEFAULT_SETTINGS.tierToasts,
                    ...parsed.tierToasts || {}
                },
                currency: {
                    ...$46c3a45bcc5b74dc$var$DEFAULT_SETTINGS.currency,
                    ...parsed.currency || {}
                }
            };
            this._refreshCart().then(()=>{
                this._lastFiredTier = this._tierForCount(this._cartPastPaperCount);
            });
        },
        // ─── Derived: subjects, years ─────────────────────────────────────────
        availableSubjects () {
            const seen = new Set();
            const result = [];
            this.papers.forEach((p)=>{
                if (p.subject && !seen.has(p.subject)) {
                    seen.add(p.subject);
                    result.push(p.subject);
                }
            });
            return result.slice().sort((a, b)=>this._subjectSortCompare(a, b));
        },
        /**
   * Subjects used for filtering, pack resolution and the accordion rows. An
   * empty selection means "no filter": landing, select-all and deselect-all
   * all show the full catalogue. Checking a subset filters down to it.
   */ effectiveSubjects () {
            const selected = this.selectedSubjects;
            return selected.length > 0 ? selected : this.availableSubjects();
        },
        /**
   * Effective subjects in display order (popularity, not selection order).
   * Used for the pack "Includes" lines and the build-your-own accordions so
   * the order stays consistent with the Step 2 grid.
   */ displaySubjects () {
            return this.effectiveSubjects().slice().sort((a, b)=>this._subjectSortCompare(a, b));
        },
        /**
   * Popularity rank for a subject — Mathematics > English > Science > Digital
   * Technologies, then anything else falls through to alphabetical. Handles
   * the common "Maths" / "Mathematics" alias.
   */ _subjectRank (subject) {
            const handle = subject.toLowerCase().trim();
            if (handle === "mathematics" || handle === "maths") return 0;
            if (handle === "english") return 1;
            if (handle === "science") return 2;
            if (handle === "digital technologies" || handle === "digital tech") return 3;
            return 99;
        },
        _subjectSortCompare (a, b) {
            const rankDiff = this._subjectRank(a) - this._subjectRank(b);
            if (rankDiff !== 0) return rankDiff;
            return a.localeCompare(b);
        },
        /**
   * Year level pills. Source: section settings `yearLevels`, populated
   * server-side from the union of `custom.difficulty_levels` values across
   * available variants. Already deduped, sorted (INT first, then
   * alphabetical), and label-resolved via the locale `t` filter for
   * per-market translation. None is selected on load — like the subject
   * cards, no selection means "no filter".
   */ availableYearLevels () {
            return this.settings.yearLevels;
        },
        /** Resolve a difficulty code to its localised label, falling back to the code. */ yearLevelLabel (code) {
            const yl = this.settings.yearLevels.find((y)=>y.code === code);
            return yl ? yl.label : code;
        },
        /**
   * For papers that cover multiple year levels (e.g. an ICAS DT 3/4 paper),
   * produce a joined label like "Year 3 / Year 4". Returns '' when the paper
   * applies to a single year level so the markup can skip the row.
   */ paperYearLevelRange (paper) {
            if (!paper.difficulties || paper.difficulties.length <= 1) return "";
            const order = this.settings.yearLevels.map((y)=>y.code);
            const rank = (code)=>{
                const i = order.indexOf(code);
                return i === -1 ? Number.MAX_SAFE_INTEGER : i;
            };
            return paper.difficulties.slice().sort((a, b)=>rank(a) - rank(b)).map((code)=>this.yearLevelLabel(code)).join(" / ");
        },
        /**
   * Resolve a subject name to its icon URL. Handleizes the subject and then
   * tries a few common aliases (e.g. "Maths" / "Mathematics") so the catalogue
   * doesn't have to use a single canonical name. Returns '' if no icon exists,
   * which the markup treats as a signal to hide the icon entirely.
   */ subjectIconUrl (subject) {
            const icons = this.settings.subjectIcons;
            const handle = subject.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
            return icons[handle] || "";
        },
        // ─── Year selection ───────────────────────────────────────────────────
        selectYear (yearLevel) {
            // Subject selections, cart-driven button states and button errors are
            // deliberately preserved across year switches (spec decision — deviates
            // from the prototype, which reset subjects to all-selected).
            this.selectedYear = yearLevel;
            // The selected year's accordion opens automatically.
            this.openAccordions = [
                yearLevel
            ];
        },
        // ─── Subject selection ────────────────────────────────────────────────
        toggleSubject (subject) {
            const subjects = this.selectedSubjects;
            if (subjects.includes(subject)) this.selectedSubjects = subjects.filter((s)=>s !== subject);
            else this.selectedSubjects = [
                ...subjects,
                subject
            ];
        },
        toggleAccordion (code) {
            const open = this.openAccordions;
            if (open.includes(code)) this.openAccordions = open.filter((c)=>c !== code);
            else this.openAccordions = [
                ...open,
                code
            ];
        },
        // ─── Papers for accordion ─────────────────────────────────────────────
        papersFor (subject, code) {
            return this.papers.filter((p)=>p.subject === subject && p.difficulties.includes(code)).slice().sort((a, b)=>parseInt(b.paperYear, 10) - parseInt(a.paperYear, 10));
        },
        /**
   * Year levels to render as accordions: every year level when All is
   * selected, otherwise just the selected one. Levels where no effective
   * subject has papers are skipped.
   */ visibleYearLevels () {
            const levels = this.settings.yearLevels;
            const candidates = this.selectedYear === null ? levels : levels.filter((yl)=>yl.code === this.selectedYear);
            return candidates.filter((yl)=>this.effectiveSubjects().some((s)=>this.papersFor(s, yl.code).length > 0));
        },
        /** True if at least one effective subject has papers at a visible year level. */ hasAnyIndividualPapers () {
            return this.visibleYearLevels().length > 0;
        },
        /**
   * Distinct individual papers across effective subjects at the visible year
   * levels. Counted by variant ID so a multi-level paper (e.g. DT 3/4) that
   * appears under several year accordions is only counted once.
   */ totalAvailablePapers () {
            const variantIds = new Set();
            this.visibleYearLevels().forEach((yl)=>{
                this.effectiveSubjects().forEach((s)=>{
                    this.papersFor(s, yl.code).forEach((p)=>variantIds.add(p.variantId));
                });
            });
            return variantIds.size;
        },
        /** ` – Year 5`-style heading suffix; empty while no year is selected. */ headingSuffix () {
            if (this.selectedYear === null) return "";
            return ` – ${this.yearLevelLabel(this.selectedYear)}`;
        },
        // ─── Pack resolution ──────────────────────────────────────────────────
        resolvePack (packId) {
            // Packs need an explicit year AND explicit subjects: a pack assembled
            // from unfiltered subjects would bundle products the parent never chose
            // (client call — avoids refund requests, esp. Digital Technologies).
            const subjects = this.selectedSubjects;
            if (this.selectedYear === null || subjects.length === 0) return [];
            const pack = (0, $0ab6db91e7d48544$export$747444d7e22037e2).find((p)=>p.id === packId);
            if (!pack) return [];
            const code = this.selectedYear;
            const allPapers = this.papers;
            const papersAtYear = allPapers.filter((p)=>p.difficulties.includes(code));
            const yearLevelOrder = this.settings.yearLevels.map((y)=>y.code);
            return pack.rule({
                papers: papersAtYear,
                allPapers: allPapers,
                subjects: subjects,
                selectedYear: code,
                yearLevelOrder: yearLevelOrder
            });
        },
        packPrice (packId) {
            const resolved = this.resolvePack(packId);
            const sum = resolved.reduce((acc, p)=>acc + p.price, 0);
            const discountPercent = (0, $0ab6db91e7d48544$export$9fd6ca145b0665f3)(resolved.length);
            const discounted = Math.round(sum * (1 - discountPercent / 100));
            return {
                sum: sum,
                discounted: discounted,
                discountPercent: discountPercent
            };
        },
        /**
   * Pack cards to render. Walks PACKS in tier order (Foundation, Essential,
   * Complete) and:
   *   - Drops packs that resolve to zero variants.
   *   - Hides any higher-tier pack whose variant set equals an already-shown
   *     lower-tier pack — with the new rules a sparse catalogue can produce
   *     identical Foundation/Essential/Complete sets, and we don't want two
   *     cards offering the same bundle.
   */ visiblePacks () {
            const result = [];
            const shownVariantSets = [];
            for (const pack of (0, $0ab6db91e7d48544$export$747444d7e22037e2)){
                const resolved = this.resolvePack(pack.id);
                if (resolved.length === 0) continue;
                const variantSet = new Set(resolved.map((p)=>p.variantId));
                const isDuplicate = shownVariantSets.some((shown)=>shown.size === variantSet.size && Array.from(variantSet).every((v)=>shown.has(v)));
                if (isDuplicate) continue;
                shownVariantSets.push(variantSet);
                const content = this.packContent[pack.contentKey] || (0, $0ab6db91e7d48544$export$e4d6ea148b051bba)[pack.contentKey];
                result.push({
                    id: pack.id,
                    contentKey: pack.contentKey,
                    displayName: content?.displayName || pack.contentKey,
                    description: content?.description || "",
                    tagline: content?.tagline || "",
                    badgeText: content?.badgeText || "",
                    popular: content?.popular || false
                });
            }
            return result;
        },
        // ─── Pack feature lines ───────────────────────────────────────────────
        packFeatures (packId) {
            const resolved = this.resolvePack(packId);
            // Per-subject paper counts in display order (popularity).
            const subjectLines = [];
            this.displaySubjects().forEach((subject)=>{
                const subjectPapers = resolved.filter((p)=>p.subject === subject);
                if (subjectPapers.length === 0) return;
                const paperWord = subjectPapers.length === 1 ? "paper" : "papers";
                const label = `${subjectPapers.length}x ${subject} ${paperWord}`;
                // Tooltip uses the real product title — for joined-year products (e.g.
                // "ICAS DT 3/4 2018"), the product title carries the correct year range
                // rather than a derived single year.
                const tooltip = subjectPapers.slice().sort((a, b)=>parseInt(b.paperYear, 10) - parseInt(a.paperYear, 10)).map((p)=>{
                    const range = this.paperYearLevelRange(p);
                    const rangePart = range ? ` (${this._escape(range)})` : "";
                    return `${this._escape(p.productTitle)}${rangePart} – ${this._escape(p.mode)}`;
                }).join("<br>");
                subjectLines.push({
                    subject: subject,
                    label: label,
                    tooltip: tooltip
                });
            });
            // Modes present (preserving Online → Interactive PDF → PDF order)
            const modeOrder = [
                "Online",
                "Interactive PDF",
                "PDF"
            ];
            const modesPresent = modeOrder.filter((m)=>resolved.some((p)=>p.mode === m));
            const formatLabel = this._joinWithAmpersand(modesPresent);
            const formatTooltip = modesPresent.map((m)=>this._tooltipForMode(m)).filter(Boolean).join("<br>");
            // Capability line. When both capabilities are present they read as a
            // mid-sentence pair: "Auto-marking & answer sheets" (lowercase second
            // item). When only one capability is present it renders capitalised on
            // its own.
            const capabilities = [];
            if (modesPresent.includes("Online") || modesPresent.includes("Interactive PDF")) capabilities.push("Auto-marking");
            // Online papers ship with answer sheets as well as auto-marking, so a
            // pack of recent (Online-mode) papers reads "Auto-marking & answer sheets".
            if (modesPresent.includes("PDF") || modesPresent.includes("Online")) capabilities.push("Answer sheets");
            const capabilityLabel = capabilities.length <= 1 ? capabilities.join(" & ") : `${capabilities[0]} & ${capabilities.slice(1).map((c)=>c.charAt(0).toLowerCase() + c.slice(1)).join(" & ")}`;
            return {
                subjectLines: subjectLines,
                formatLabel: formatLabel,
                formatTooltip: formatTooltip,
                capabilityLabel: capabilityLabel
            };
        },
        _joinWithAmpersand (items) {
            if (items.length === 0) return "";
            if (items.length === 1) return items[0];
            if (items.length === 2) return `${items[0]} & ${items[1]}`;
            return `${items.slice(0, -1).join(", ")} & ${items[items.length - 1]}`;
        },
        _tooltipForMode (mode) {
            if (mode === "Online") return this.settings.tooltips.online;
            if (mode === "Interactive PDF") return this.settings.tooltips.interactivePdf;
            if (mode === "PDF") return this.settings.tooltips.pdf;
            return "";
        },
        modeTooltip (mode) {
            return this._tooltipForMode(mode);
        },
        _escape (text) {
            return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
        },
        // ─── Money formatting ─────────────────────────────────────────────────
        /**
   * Format a cents amount using the section's money-format template. Used for
   * client-computed pack totals; per-paper prices come pre-formatted from
   * Liquid as `priceFormatted` on each Paper entry.
   */ formatMoney (cents) {
            const settings = this.settings.currency;
            const format = settings.moneyFormat || "${{amount}}";
            return $46c3a45bcc5b74dc$var$substituteAmount(format, cents);
        },
        // ─── Add to cart ──────────────────────────────────────────────────────
        async addIndividual (variantId) {
            const buttonId = `paper:${variantId}`;
            if (this.buttonStates[buttonId] === "loading") return;
            this._setButtonState(buttonId, "loading");
            this._clearButtonError(buttonId);
            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                });
                if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
                this._setButtonState(buttonId, "added");
                this._showSecondToast("past paper");
                this._refreshCart().then(()=>this._maybeFireTierToast());
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error("past-papers-builder: individual add failed", e);
                this._setButtonState(buttonId, "idle");
                this._setButtonError(buttonId, "Could not add to cart. Please try again.");
            }
        },
        /**
   * Remove an individual paper from the cart. Triggered by clicking the
   * "Added" button (which swaps to "Remove" on hover). Uses `/cart/update.js`
   * because `/cart/change.js`'s `id` field requires a line index or line key,
   * not a variant ID — `update.js` takes a variant-ID-keyed `updates` map.
   */ async removeIndividual (variantId) {
            const buttonId = `paper:${variantId}`;
            if (this.buttonStates[buttonId] === "loading") return;
            this._setButtonState(buttonId, "loading");
            this._clearButtonError(buttonId);
            try {
                const response = await fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        updates: {
                            [variantId]: 0
                        }
                    })
                });
                if (!response.ok) throw new Error(`Cart remove failed: ${response.status}`);
                this._setButtonState(buttonId, "idle");
                this._refreshCart();
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error("past-papers-builder: individual remove failed", e);
                this._setButtonState(buttonId, "added");
                this._setButtonError(buttonId, "Could not remove from cart. Please try again.");
            }
        },
        async addPack (packId) {
            const buttonId = `pack:${packId}`;
            if (this.buttonStates[buttonId] === "loading") return;
            const resolved = this.resolvePack(packId);
            if (resolved.length === 0) return;
            this._setButtonState(buttonId, "loading");
            this._clearButtonError(buttonId);
            try {
                const items = resolved.map((p)=>({
                        id: p.variantId,
                        quantity: 1
                    }));
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: items
                    })
                });
                if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
                this._setButtonState(buttonId, "added");
                this._showSecondToast("pack");
                this._refreshCart();
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error("past-papers-builder: pack add failed", e);
                this._setButtonState(buttonId, "idle");
                this._setButtonError(buttonId, "Could not add to cart. Please try again.");
            }
        },
        /**
   * Remove a pack's variants from the cart. Triggered by clicking the "Added
   * to cart" button (which swaps to "Remove from cart" on hover). Sets every
   * pack-resolved variant's quantity to 0 in a single `/cart/update.js` call.
   */ async removePack (packId) {
            const buttonId = `pack:${packId}`;
            if (this.buttonStates[buttonId] === "loading") return;
            const resolved = this.resolvePack(packId);
            if (resolved.length === 0) return;
            this._setButtonState(buttonId, "loading");
            this._clearButtonError(buttonId);
            try {
                const updates = {};
                resolved.forEach((p)=>{
                    updates[p.variantId] = 0;
                });
                const response = await fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        updates: updates
                    })
                });
                if (!response.ok) throw new Error(`Cart remove failed: ${response.status}`);
                this._setButtonState(buttonId, "idle");
                this._refreshCart();
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error("past-papers-builder: pack remove failed", e);
                this._setButtonState(buttonId, "added");
                this._setButtonError(buttonId, "Could not remove from cart. Please try again.");
            }
        },
        _setButtonState (buttonId, state) {
            this.buttonStates = {
                ...this.buttonStates,
                [buttonId]: state
            };
        },
        _setButtonError (buttonId, message) {
            this.buttonErrors = {
                ...this.buttonErrors,
                [buttonId]: message
            };
        },
        _clearButtonError (buttonId) {
            if (!(buttonId in this.buttonErrors)) return;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [buttonId]: _omitted, ...rest } = this.buttonErrors;
            this.buttonErrors = rest;
        },
        /**
   * Fetch /cart.js, update the header badge, and count how many past-paper
   * variants are in the cart so tier-toast thresholds reflect existing items
   * (not just session adds). Parallel adds resolve out of order, so each
   * call aborts the previous in-flight request.
   */ async _refreshCart () {
            if (this._cartController) this._cartController.abort();
            const controller = new AbortController();
            this._cartController = controller;
            try {
                const response = await fetch("/cart.js", {
                    headers: {
                        Accept: "application/json"
                    },
                    signal: controller.signal
                });
                if (!response.ok) return;
                const cart = await response.json();
                const itemCount = typeof cart.item_count === "number" ? cart.item_count : 0;
                this._writeCartBadge(".header__cart-link", itemCount);
                const paperIds = new Set(this.papers.map((p)=>p.variantId));
                let pastPaperCount = 0;
                (cart.items || []).forEach((item)=>{
                    if (paperIds.has(item.variant_id)) pastPaperCount += item.quantity;
                });
                this._cartPastPaperCount = pastPaperCount;
            } catch (e) {
                if (e instanceof DOMException && e.name === "AbortError") return;
                // eslint-disable-next-line no-console
                console.warn("past-papers-builder: cart refresh failed", e);
            } finally{
                if (this._cartController === controller) this._cartController = null;
            }
        },
        _writeCartBadge (selector, count) {
            document.querySelectorAll(selector).forEach((node)=>{
                const label = node.querySelector("label");
                if (label) {
                    if (count > 0) label.textContent = String(count);
                    else label.remove();
                    return;
                }
                if (count > 0) {
                    // No existing label — create one to match the header.liquid markup.
                    const newLabel = document.createElement("label");
                    newLabel.setAttribute("aria-label", "Cart Items");
                    newLabel.textContent = String(count);
                    node.appendChild(newLabel);
                }
            });
        },
        // ─── Toasts ───────────────────────────────────────────────────────────
        _showSecondToast (type) {
            // Capitalise the substituted word only when `{type}` is the first thing
            // in the template (so the default "{type} added to cart" reads "Pack added
            // to cart"). A merchant-authored template like "You added a {type}" keeps
            // the token lowercase, which reads naturally.
            const template = this.settings.toast.headingTemplate || "{type} added to cart";
            const tokenAtStart = template.indexOf("{type}") === 0;
            const value = tokenAtStart ? type.charAt(0).toUpperCase() + type.slice(1) : type;
            this.secondToast = {
                visible: true,
                heading: template.replace("{type}", value)
            };
            if (this._secondToastTimer) window.clearTimeout(this._secondToastTimer);
            this._secondToastTimer = window.setTimeout(()=>{
                this.dismissSecondToast();
            }, $46c3a45bcc5b74dc$var$SECOND_TOAST_DISMISS_MS);
        },
        dismissSecondToast () {
            this.secondToast = {
                ...this.secondToast,
                visible: false
            };
            if (this._secondToastTimer) {
                window.clearTimeout(this._secondToastTimer);
                this._secondToastTimer = 0;
            }
        },
        /** Highest tier-toast threshold the given paper count has reached, or 0. */ _tierForCount (count) {
            if (count >= 8) return 8;
            if (count >= 5) return 5;
            if (count >= 3) return 3;
            return 0;
        },
        _maybeFireTierToast () {
            const tier = this._tierForCount(this._cartPastPaperCount);
            if (tier === 0 || tier <= this._lastFiredTier) return;
            const message = this.settings.tierToasts[String(tier)];
            if (!message) return;
            this._lastFiredTier = tier;
            this.tierToast = {
                visible: true,
                message: message
            };
            if (this._tierToastTimer) window.clearTimeout(this._tierToastTimer);
            this._tierToastTimer = window.setTimeout(()=>{
                this.dismissTierToast();
            }, $46c3a45bcc5b74dc$var$TIER_TOAST_DISMISS_MS);
        },
        dismissTierToast () {
            this.tierToast = {
                ...this.tierToast,
                visible: false
            };
            if (this._tierToastTimer) {
                window.clearTimeout(this._tierToastTimer);
                this._tierToastTimer = 0;
            }
        },
        proceedToCart () {
            window.location.href = "/cart";
        },
        // ─── Reset ────────────────────────────────────────────────────────────
        resetSelections () {
            // Back to the page-load default: no year, no subject filter,
            // all accordions closed.
            this.selectedYear = null;
            this.selectedSubjects = [];
            this.buttonStates = {};
            this.buttonErrors = {};
            this.openAccordions = [];
            this.dismissSecondToast();
            this.dismissTierToast();
            // _cartPastPaperCount and _lastFiredTier intentionally NOT reset — the
            // cart still contains the previous child's items, and we don't want to
            // re-fire tier toasts the customer has already seen.
            // Scroll the whole page to the top so the site header + Step 1 instructions
            // are visible (scrolling to the section root left "1. Select year level"
            // cropped under the sticky header).
            if (typeof window !== "undefined" && typeof window.scrollTo === "function") window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }));



(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("loadingButton", ()=>({
        init () {
            const loadingIcon = this.$el.querySelector(".icon-loading");
            loadingIcon.classList.remove("hidden");
            loadingIcon.setAttribute("x-show", "loading");
            this.$refs.label.setAttribute("x-show", "!loading");
            this.$el.setAttribute("x-cloak", "true");
        }
    }));



(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("schoolCollectionLink", ()=>({
        init () {
            if (!window.Cookies) return;
            const Cookies = window.Cookies;
            const collection_url = Cookies.get("collection_url");
            if (collection_url) {
                this.$el.setAttribute("href", collection_url);
                this.$el.querySelector("span").textContent = "Back to 'Select subjects'";
            }
        }
    }));


function $577cb23701943602$export$c1428fdaca6ad73f(locale) {
    const currentCountry = window.Shopify.country;
    if (currentCountry === locale) return;
    const formId = crypto.randomUUID();
    const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="source" value="geolocation_selector">
      <input name="country_code" value="${locale}">
      <input name="return_to" value="${window.location.pathname}">
    </form>
  `;
    // eslint-disable-next-line no-console
    console.log(`Updating locale to "${locale}"...`);
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
}
function $577cb23701943602$var$updateSchoolRegion() {
    const shouldUpdateRegion = window.localStorage.getItem("force-school-region") === "true";
    const newRegion = window.currentCustomer?.countryId;
    if (shouldUpdateRegion && newRegion) {
        window.localStorage.removeItem("force-school-region");
        // Taking first two characters of the country code to convert AUD -> AU
        $577cb23701943602$export$c1428fdaca6ad73f(newRegion.substring(0, 2));
    }
}
window.addEventListener("load", ()=>{
    $577cb23701943602$var$updateSchoolRegion();
});



(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).data("pps", ()=>({
        isEnabled: false,
        registryOpen: true,
        baseParentLink: "",
        error: null,
        warning: null,
        success: null,
        ppsSettings: null,
        loading: false,
        copied: false,
        copiedTimeout: null,
        activeVariants: [],
        selectedVariants: [],
        // Levy state
        hasLevyAccess: false,
        levyEnabled: false,
        levyEnabledOriginal: false,
        levyLoading: false,
        levyStats: {
            total: 0,
            count: 0
        },
        init: async function() {
            this.baseParentLink = this.$el.dataset.ppsLink;
            this.registryOpen = this.$el.dataset.registryOpen === "true";
            this.hasLevyAccess = this.$el.dataset.hasLevyAccess === "true";
            this.fetchParentPaymentStatus();
            this.attachUnsavedChangesAlert();
            this.initTooltips();
            this.$refs.subjectsForm.addEventListener("submit", this.handleSubjectsFormSubmit.bind(this));
            // If parent payment is enabled but there is 0 active variants, show a warning
            this.$watch("activeVariants,isEnabled", (value)=>{
                if (this.isEnabled && value.length === 0) this.setMessage("warning", "Parent payment system is enabled but there are no subject selected. Please select subjects and ensure you click 'Update Subjects' to confirm your selection.", false, true);
            });
        },
        attachUnsavedChangesAlert: function() {
            window.addEventListener("beforeunload", (event)=>{
                // Only show confirmation dialog if there are pending changes
                if (this.getPendingCount() > 0) {
                    const message = "You have unsaved subject changes. Are you sure you want to leave?";
                    event.preventDefault();
                    event.returnValue = message; // For older browsers
                    return message; // For modern browsers
                }
            });
        },
        initTooltips: function() {
            // Initialize Bootstrap tooltips after a short delay to ensure DOM is ready
            this.$nextTick(()=>{
                if (typeof jQuery !== "undefined" && jQuery.fn.tooltip) jQuery(this.$el).find('[data-toggle="tooltip"]').tooltip();
            });
        },
        getParentPageLink () {
            if (!this.ppsSettings) return "";
            return new URL(`/pages/parent-payment/${this.ppsSettings.pps_code}`, this.baseParentLink);
        },
        showConfirmation () {
            this.$refs.confirmation.showModal();
        },
        async copyDetails () {
            const text = `Parent Payment System code: ${this.ppsSettings.pps_code}\nLink to buy: ${this.getParentPageLink()}`;
            try {
                await navigator.clipboard.writeText(text);
            } catch (error) {
                console.error("Could not copy parent payment details:", error);
                return;
            }
            clearTimeout(this.copiedTimeout);
            this.copied = true;
            this.copiedTimeout = setTimeout(()=>{
                this.copied = false;
            }, 3000);
        },
        fetchParentPaymentStatus: async function() {
            this.loading = true;
            this.clearMessages();
            try {
                const response = await fetch("/apps/acidgreen/parent-payment/status");
                const data = await response.json();
                this.ppsSettings = data;
                this.isEnabled = data.enabled;
                this.activeVariants = data.variants?.map((variant)=>variant.id.replace(/\D/g, "")) || [];
                this.selectedVariants = this.activeVariants;
                // Set levy state from backend
                this.levyEnabled = data.levy_enabled || false;
                this.levyEnabledOriginal = this.levyEnabled;
                this.levyStats = data.levy_stats || {
                    total: 0,
                    count: 0
                };
                // Re-initialize tooltips after data loads and elements become visible
                this.initTooltips();
            } catch (error) {
                console.error("Error fetching parent payment status:", error);
                this.setMessage("error", "Could not fetch parent payment system status.");
            } finally{
                this.loading = false;
            }
        },
        clearMessages: function() {
            this.error = null;
            this.warning = null;
            this.success = null;
        },
        setMessage: function(type, message, shouldClear = true, shouldScrollTo = false) {
            if (shouldClear) this.clearMessages();
            this[type] = message;
            if (shouldScrollTo) this.$refs.notifications.scrollIntoView({
                behavior: "smooth"
            });
        },
        async togglePaymentSystem () {
            if (this.loading) return;
            try {
                this.loading = true;
                this.clearMessages();
                const url = `/apps/acidgreen/parent-payment/status`;
                const response = await fetch(url, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        enabled: !this.isEnabled
                    })
                });
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                this.isEnabled = data.enabled;
                if (this.ppsSettings) {
                    this.ppsSettings.enabled = this.isEnabled;
                    this.ppsSettings.pps_code = data.pps_code;
                }
                if (this.isEnabled && this.ppsSettings) this.showConfirmation();
            } catch (error) {
                this.setMessage("error", "An error occurred while updating the parent payment system status.", true, true);
                console.error("An error occurred:", error);
            } finally{
                this.loading = false;
            }
        },
        handleInput () {
            const inputs = this.$refs.variants.querySelectorAll("input[data-variant]");
            this.selectedVariants = Array.from(inputs).filter((input)=>input.checked).map((input)=>input.dataset.variant);
        },
        getPendingCount () {
            let count = 0;
            // Count variants that are active but not selected (will be removed)
            for (const variantId of this.activeVariants)if (!this.selectedVariants.includes(variantId)) count++;
            // Count variants that are selected but not active (will be added)
            for (const variantId of this.selectedVariants)if (!this.activeVariants.includes(variantId)) count++;
            return count;
        },
        isPending (variantId) {
            if (this.activeVariants.includes(variantId) && !this.selectedVariants.includes(variantId)) return true;
            if (!this.activeVariants.includes(variantId) && this.selectedVariants.includes(variantId)) return true;
            return false;
        },
        handleSubjectsFormSubmit: function(event) {
            event.preventDefault();
            this.updateEnabledVariants();
        },
        async updateEnabledVariants () {
            if (this.getPendingCount() <= 0) return;
            if (this.loading) return;
            const payload = {
                variants: this.selectedVariants
            };
            try {
                this.loading = true;
                this.clearMessages();
                const url = `/apps/acidgreen/parent-payment/variants`;
                const response = await fetch(url, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                this.activeVariants = data.variants;
                // The pop-up tells schools parents can now buy, which is only true while PPS is enabled.
                if (this.isEnabled) this.showConfirmation();
            } catch (error) {
                console.error("An error occurred:", error);
                this.setMessage("error", "An error occurred while updating the enabled variants.", true, true);
            } finally{
                this.loading = false;
            }
        },
        hasLevyChanges () {
            return this.levyEnabled !== this.levyEnabledOriginal;
        },
        async saveLevySettings () {
            if (!this.hasLevyChanges() || this.levyLoading) return;
            try {
                this.levyLoading = true;
                this.clearMessages();
                const url = `/apps/acidgreen/parent-payment/levy`;
                const response = await fetch(url, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        levy_enabled: this.levyEnabled
                    })
                });
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                this.levyEnabled = data.levy_enabled;
                this.levyEnabledOriginal = data.levy_enabled;
                this.setMessage("success", "School support fee settings updated successfully.", true, true);
            } catch (error) {
                console.error("An error occurred:", error);
                this.setMessage("error", "An error occurred while updating the school support fee settings.", true, true);
            } finally{
                this.levyLoading = false;
            }
        },
        formatMoney (cents) {
            return "$" + (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
        }
    }));


(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).plugin((0, $f5d5684b6dfa86ec$export$2e2bcd8739ae039));
(0, $5599ea74f46bbff6$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=global.js.map
